import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { Check, Loader2, LogOut, Lock, Trash2, Users, FileText, Star, Clock, Calendar, Image as ImageIcon, ChevronUp, ChevronDown, Eye, EyeOff, Handshake, Pencil, MessageSquare, Send, Paperclip } from "lucide-react";
import SiteImages from "@/components/landing/SiteImages";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function formatDetail(detail) {
  if (detail == null) return "Etwas ist schiefgelaufen. Bitte erneut versuchen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

function fmtDT(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return "";
  return d.toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
}
const STATUS_LABEL = { offen: "Offen", erledigt: "Erledigt", widerrufen: "Widerrufen", angenommen: "Angenommen", abgelaufen: "Abgelaufen", vorgeschlagen: "Vorgeschlagen", ausstehend: "Ausstehend", bestaetigt: "Bestätigt", storniert: "Storniert" };
const apptBadgeCls = (s) => s === "bestaetigt" ? "bg-emerald-500/15 text-emerald-400" : s === "storniert" ? "bg-red-500/15 text-red-400" : s === "vorgeschlagen" ? "bg-sky-500/15 text-sky-400" : "bg-[#F5B301]/15 text-[#F5B301]";
const statusLabel = (s) => STATUS_LABEL[s] || (s ? s[0].toUpperCase() + s.slice(1) : "");

export default function Admin() {
  const [user, setUser] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [authMode, setAuthMode] = useState("login");
  const [regName, setRegName] = useState("");
  const [pwForm, setPwForm] = useState({ current: "", next: "", confirm: "" });
  const [savingPw, setSavingPw] = useState(false);
  const [enquiries, setEnquiries] = useState([]);
  const [missions, setMissions] = useState([]);
  const [missionForm, setMissionForm] = useState({ nr: "", title: "", ort: "", datum: "" });
  const [missionFile, setMissionFile] = useState(null);
  const [savingMission, setSavingMission] = useState(false);
  const [team, setTeam] = useState([]);
  const [teamForm, setTeamForm] = useState({ name: "", role: "", contact: "", text: "" });
  const [teamFile, setTeamFile] = useState(null);
  const [savingTeam, setSavingTeam] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [docForm, setDocForm] = useState({ einsatz_nr: "", title: "", extra_terms: "" });
  const [docFile, setDocFile] = useState(null);
  const [savingDoc, setSavingDoc] = useState(false);
  const [reviews, setReviews] = useState([]);
  const [reviewForm, setReviewForm] = useState({ name: "", role: "", rating: 5, text: "" });
  const [savingReview, setSavingReview] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [ticketReply, setTicketReply] = useState({});
  const [custRequests, setCustRequests] = useState([]);
  const [custDocs, setCustDocs] = useState([]);
  const [custDocForm, setCustDocForm] = useState({ customer_email: "", title: "" });
  const [custDocFile, setCustDocFile] = useState(null);
  const [savingCustDoc, setSavingCustDoc] = useState(false);
  const [offers, setOffers] = useState([]);
  const [offerForm, setOfferForm] = useState({ customer_email: "", title: "", valid_until: "" });
  const [offerFile, setOfferFile] = useState(null);
  const [savingOffer, setSavingOffer] = useState(false);
  const [staff, setStaff] = useState([]);
  const [staffForm, setStaffForm] = useState({ name: "", email: "", password: "" });
  const [savingStaff, setSavingStaff] = useState(false);
  const [gallery, setGallery] = useState([]);
  const [publicTeam, setPublicTeam] = useState([]);
  const [myProfile, setMyProfile] = useState(null);
  const [myGallery, setMyGallery] = useState([]);
  const [myCaption, setMyCaption] = useState("");
  const [savingMyPhoto, setSavingMyPhoto] = useState(false);
  const [savingMyGallery, setSavingMyGallery] = useState(false);
  const [galleryCaption, setGalleryCaption] = useState("");
  const [galleryFile, setGalleryFile] = useState(null);
  const [savingGallery, setSavingGallery] = useState(false);
  const [partners, setPartners] = useState([]);
  const [partnerForm, setPartnerForm] = useState({ name: "", website: "", description: "" });
  const [partnerFile, setPartnerFile] = useState(null);
  const [savingPartner, setSavingPartner] = useState(false);
  const [roles, setRoles] = useState([]);
  const [permAreas, setPermAreas] = useState([]);
  const [roleName, setRoleName] = useState("");
  const [rolePerms, setRolePerms] = useState([]);
  const [savingRole, setSavingRole] = useState(false);
  const [editingRoleId, setEditingRoleId] = useState(null);
  const [activity, setActivity] = useState([]);
  const [visitStats, setVisitStats] = useState(null);
  const [siteStats, setSiteStats] = useState([]);
  const [savingStats, setSavingStats] = useState(false);
  const [faqs, setFaqs] = useState([]);
  const [faqForm, setFaqForm] = useState({ question: "", answer: "" });
  const [savingFaq, setSavingFaq] = useState(false);
  const [appointments, setAppointments] = useState([]);
  const [apptForm, setApptForm] = useState({ title: "", date: "", start: "", end: "", location: "", customer_email: "", note: "" });
  const [editApptId, setEditApptId] = useState(null);
  const [savingAppt, setSavingAppt] = useState(false);
  const [activeTab, setActiveTab] = useState("anfragen");
  const [chatThreads, setChatThreads] = useState([]);
  const [chatEmail, setChatEmail] = useState(null);
  const [chatMsgs, setChatMsgs] = useState([]);
  const [chatInput, setChatInput] = useState("");
  const [chatSending, setChatSending] = useState(false);
  const [chatUnread, setChatUnread] = useState(0);
  const chatFileRef = useRef(null);
  const chatEndRef = useRef(null);
  const [editMission, setEditMission] = useState(null);
  const [savingEditMission, setSavingEditMission] = useState(false);
  const [showcaseItems, setShowcaseItems] = useState([]);
  const [cardForm, setCardForm] = useState({ title: "", meta: "", text: "" });
  const [cardFile, setCardFile] = useState(null);
  const [docForm2, setDocForm2] = useState({ title: "", meta: "" });
  const [docFile2, setDocFile2] = useState(null);
  const [savingShowcase, setSavingShowcase] = useState(false);

  useEffect(() => {
    document.title = "Admin — DROPS TFR";
    axios
      .get(`${API}/auth/me`, { withCredentials: true })
      .then((res) => (res.data.role === "customer" ? setUser(false) : setUser(res.data)))
      .catch(() => setUser(false));
  }, []);

  useEffect(() => {
    if (user) {
      const allowed = user.role === "admin" ? null : (user.permissions || []);
      const has = (a) => allowed === null || allowed.includes(a);
      if (has("enquiries")) {
        axios
          .get(`${API}/enquiries`, { withCredentials: true })
          .then((res) => setEnquiries(res.data))
          .catch(() => toast.error("Anfragen konnten nicht geladen werden"));
      }
      if (has("missions")) {
        axios
          .get(`${API}/missions`, { withCredentials: true })
          .then((res) => setMissions(res.data))
          .catch(() => {});
      }
      axios
        .get(`${API}/team-members`, { withCredentials: true })
        .then((res) => setTeam(res.data))
        .catch(() => {});
      if (has("documents")) {
        axios
          .get(`${API}/documents`, { withCredentials: true })
          .then((res) => setDocuments(res.data))
          .catch(() => {});
      }
      if (has("reviews")) {
        axios
          .get(`${API}/reviews`, { withCredentials: true })
          .then((res) => setReviews(res.data))
          .catch(() => {});
      }
      if (has("customers")) {
        axios.get(`${API}/customers`, { withCredentials: true }).then((r) => setCustomers(r.data)).catch(() => {});
        axios.get(`${API}/customer-requests`, { withCredentials: true }).then((r) => setCustRequests(r.data)).catch(() => {});
        axios.get(`${API}/support-tickets`, { withCredentials: true }).then((r) => setTickets(r.data)).catch(() => {});
        axios.get(`${API}/appointments`, { withCredentials: true }).then((r) => setAppointments(r.data)).catch(() => {});
        axios.get(`${API}/customer-documents`, { withCredentials: true }).then((r) => setCustDocs(r.data)).catch(() => {});
      }
      if (has("offers")) {
        axios.get(`${API}/offers`, { withCredentials: true }).then((r) => setOffers(r.data)).catch(() => {});
      }
      if (has("gallery")) {
        axios.get(`${API}/gallery`, { withCredentials: true }).then((r) => setGallery(r.data)).catch(() => {});
      }
      axios.get(`${API}/team`).then((r) => setPublicTeam(r.data)).catch(() => {});
      axios.get(`${API}/showcase`).then((r) => setShowcaseItems(r.data)).catch(() => {});
      if (user.role === "team") {
        axios.get(`${API}/me/profile`, { withCredentials: true }).then((r) => setMyProfile(r.data)).catch(() => {});
        axios.get(`${API}/me/gallery`, { withCredentials: true }).then((r) => setMyGallery(r.data)).catch(() => {});
      }
      if (user.role === "admin") {
        axios.get(`${API}/staff`, { withCredentials: true }).then((r) => setStaff(r.data)).catch(() => {});
        axios.get(`${API}/partners`, { withCredentials: true }).then((r) => setPartners(r.data)).catch(() => {});
        axios.get(`${API}/roles`, { withCredentials: true }).then((r) => setRoles(r.data)).catch(() => {});
        axios.get(`${API}/permissions`, { withCredentials: true }).then((r) => setPermAreas(r.data)).catch(() => {});
        axios.get(`${API}/activity`, { withCredentials: true }).then((r) => setActivity(r.data)).catch(() => {});
        axios.get(`${API}/admin/visits`, { withCredentials: true }).then((r) => setVisitStats(r.data)).catch(() => {});
        axios.get(`${API}/site-stats`).then((r) => setSiteStats(r.data.items || [])).catch(() => {});
        axios.get(`${API}/faqs`).then((r) => setFaqs(r.data)).catch(() => {});
      }
    }
  }, [user]);

  const submitMission = async (e) => {
    e.preventDefault();
    if (!missionFile) {
      toast.error("Bitte ein Foto auswählen");
      return;
    }
    setSavingMission(true);
    try {
      const data = new FormData();
      data.append("nr", missionForm.nr);
      data.append("title", missionForm.title);
      data.append("ort", missionForm.ort);
      data.append("datum", missionForm.datum);
      data.append("file", missionFile);
      const res = await axios.post(`${API}/missions`, data, { withCredentials: true });
      setMissions([res.data, ...missions]);
      setMissionForm({ nr: "", title: "", ort: "", datum: "" });
      setMissionFile(null);
      e.target.reset();
      toast.success("Einsatz eingetragen — jetzt im Log sichtbar");
    } catch (err) {
      toast.error(formatDetail(err.response?.data?.detail));
    } finally {
      setSavingMission(false);
    }
  };

  const deleteMission = async (id) => {
    try {
      await axios.delete(`${API}/missions/${id}`, { withCredentials: true });
      setMissions(missions.filter((m) => m.id !== id));      toast.success("Einsatz entfernt");
    } catch {
      toast.error("Löschen fehlgeschlagen");
    }
  };

  const refreshMissions = () =>
    axios.get(`${API}/missions`).then((r) => setMissions(r.data)).catch(() => {});

  const uploadMissionGallery = async (missionId, file) => {
    if (!file) return;
    const data = new FormData(); data.append("file", file);
    try {
      await axios.post(`${API}/missions/${missionId}/gallery`, data, { withCredentials: true });
      await refreshMissions();
      toast.success("Bild zum Einsatz hinzugefügt");
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
  };

  const deleteMissionGallery = async (itemId) => {
    try {
      await axios.delete(`${API}/mission-gallery/${itemId}`, { withCredentials: true });
      await refreshMissions();
      toast.success("Bild entfernt");
    } catch { toast.error("Löschen fehlgeschlagen"); }
  };

  const setMissionCover = async (missionId, storagePath) => {
    try {
      await axios.patch(`${API}/missions/${missionId}/cover`, { storage_path: storagePath }, { withCredentials: true });
      await refreshMissions();
      toast.success("Titelbild gesetzt");
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
  };

  const saveEditMission = async (e) => {
    e.preventDefault();
    setSavingEditMission(true);
    try {
      const data = new FormData();
      data.append("nr", editMission.nr || "");
      data.append("title", editMission.title || "");
      data.append("ort", editMission.ort || "");
      data.append("datum", editMission.datum || "");
      data.append("status", editMission.status || "");
      if (editMission._file) data.append("file", editMission._file);
      await axios.patch(`${API}/missions/${editMission.id}`, data, { withCredentials: true });
      await refreshMissions();
      setEditMission(null);
      toast.success("Einsatz aktualisiert");
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
    finally { setSavingEditMission(false); }
  };

  const refreshShowcase = () => axios.get(`${API}/showcase`).then((r) => setShowcaseItems(r.data)).catch(() => {});

  const submitCard = async (e) => {
    e.preventDefault();
    if (!cardFile) { toast.error("Bitte ein Bild wählen"); return; }
    setSavingShowcase(true);
    try {
      const data = new FormData();
      data.append("type", "card");
      data.append("title", cardForm.title);
      data.append("meta", cardForm.meta);
      data.append("text", cardForm.text);
      data.append("file", cardFile);
      await axios.post(`${API}/showcase`, data, { withCredentials: true });
      await refreshShowcase();
      setCardForm({ title: "", meta: "", text: "" }); setCardFile(null); e.target.reset();
      toast.success("Referenz-Karte hinzugefügt");
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
    finally { setSavingShowcase(false); }
  };

  const submitDoc2 = async (e) => {
    e.preventDefault();
    if (!docFile2) { toast.error("Bitte ein Bild wählen"); return; }
    setSavingShowcase(true);
    try {
      const data = new FormData();
      data.append("type", "doc");
      data.append("title", docForm2.title);
      data.append("meta", docForm2.meta);
      data.append("file", docFile2);
      await axios.post(`${API}/showcase`, data, { withCredentials: true });
      await refreshShowcase();
      setDocForm2({ title: "", meta: "" }); setDocFile2(null); e.target.reset();
      toast.success("Dokument-Bild hinzugefügt");
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
    finally { setSavingShowcase(false); }
  };

  const replaceShowcaseImage = async (id, file) => {
    if (!file) return;
    try {
      const data = new FormData(); data.append("file", file);
      await axios.patch(`${API}/showcase/${id}`, data, { withCredentials: true });
      await refreshShowcase();
      toast.success("Bild ersetzt");
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
  };

  const saveShowcaseText = async (id, fields) => {
    try {
      const data = new FormData();
      Object.entries(fields).forEach(([k, v]) => data.append(k, v ?? ""));
      await axios.patch(`${API}/showcase/${id}`, data, { withCredentials: true });
      await refreshShowcase();
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
  };

  const deleteShowcase = async (id) => {
    try {
      await axios.delete(`${API}/showcase/${id}`, { withCredentials: true });
      setShowcaseItems((s) => s.filter((x) => x.id !== id));
      toast.success("Eintrag gelöscht");
    } catch { toast.error("Löschen fehlgeschlagen"); }
  };

  const deleteCustomer = async (email) => {
    if (!window.confirm(`Kunde ${email} und ALLE zugehörigen Daten (Anfragen, Dokumente, Angebote, Tickets) unwiderruflich löschen?`)) return;
    try {
      await axios.delete(`${API}/customers/${encodeURIComponent(email)}`, { withCredentials: true });
      setCustomers((c) => c.filter((x) => x.email !== email));
      setTickets((t) => t.filter((x) => x.customer_email !== email));
      toast.success("Kunde gelöscht");
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
  };
  const setCustomerStatus = async (email, status) => {
    try {
      await axios.patch(`${API}/customers/${encodeURIComponent(email)}/status`, { status }, { withCredentials: true });
      setCustomers((c) => c.map((x) => (x.email === email ? { ...x, customer_status: status } : x)));
      toast.success(status === "approved" ? "Kunde freigeschaltet" : status === "blocked" ? "Kunde gesperrt" : "Status aktualisiert");
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
  };

  const replyTicket = async (id) => {
    const text = (ticketReply[id] || "").trim();
    if (!text) { toast.error("Bitte eine Nachricht eingeben"); return; }
    try {
      await axios.post(`${API}/support-tickets/${id}/reply`, { message: text }, { withCredentials: true });
      const r = await axios.get(`${API}/support-tickets`, { withCredentials: true });
      setTickets(r.data);
      setTicketReply({ ...ticketReply, [id]: "" });
      toast.success("Antwort gesendet");
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
  };

  const setTicketStatus = async (id, status) => {
    try {
      await axios.patch(`${API}/support-tickets/${id}/status`, { status }, { withCredentials: true });
      setTickets((t) => t.map((x) => (x.id === id ? { ...x, status } : x)));
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
  };

  const loadChatThreads = () => {
    axios.get(`${API}/chat/threads`, { withCredentials: true }).then((r) => setChatThreads(r.data)).catch(() => {});
    axios.get(`${API}/chat/unread-total`, { withCredentials: true }).then((r) => setChatUnread(r.data.unread)).catch(() => {});
  };
  const refreshThread = async (email) => {
    const em = email || chatEmail;
    if (!em) return;
    try { const r = await axios.get(`${API}/chat/${encodeURIComponent(em)}`, { withCredentials: true }); setChatMsgs(r.data); } catch {}
  };
  const openThread = async (email) => {
    setChatEmail(email);
    await refreshThread(email);
    loadChatThreads();
  };
  const sendChatMsg = async () => {
    const text = chatInput.trim();
    if (!text || !chatEmail || chatSending) return;
    setChatSending(true);
    try { await axios.post(`${API}/chat/${encodeURIComponent(chatEmail)}`, { text }, { withCredentials: true }); setChatInput(""); await refreshThread(); loadChatThreads(); }
    catch { toast.error("Nachricht konnte nicht gesendet werden"); }
    finally { setChatSending(false); }
  };
  const sendChatImg = async (file) => {
    if (!file || !chatEmail) return;
    setChatSending(true);
    try { const fd = new FormData(); fd.append("file", file); await axios.post(`${API}/chat/${encodeURIComponent(chatEmail)}/upload`, fd, { withCredentials: true }); await refreshThread(); loadChatThreads(); }
    catch { toast.error("Anhang konnte nicht gesendet werden"); }
    finally { setChatSending(false); if (chatFileRef.current) chatFileRef.current.value = ""; }
  };
  useEffect(() => {
    if (!user) return;
    const allowed = user.role === "admin" ? null : (user.permissions || []);
    if (!(allowed === null || allowed.includes("customers"))) return;
    loadChatThreads();
    const iv = setInterval(() => { loadChatThreads(); if (chatEmail) refreshThread(); }, 5000);
    return () => clearInterval(iv);
  }, [user, chatEmail]);
  useEffect(() => { chatEndRef.current?.scrollIntoView({ behavior: "smooth" }); }, [chatMsgs]);

  const updateStatItem = (id, field, value) => setSiteStats((s) => s.map((it) => (it.id === id ? { ...it, [field]: value } : it)));
  const addStatItem = () => setSiteStats((s) => [...s, { id: `new-${Date.now()}`, label: "Neue Kennzahl", value: "0", suffix: "" }]);
  const removeStatItem = (id) => setSiteStats((s) => s.filter((it) => it.id !== id));
  const saveSiteStats = async () => {
    setSavingStats(true);
    try {
      const res = await axios.put(`${API}/site-stats`, { items: siteStats }, { withCredentials: true });
      setSiteStats(res.data.items);
      toast.success("Kennzahlen gespeichert — jetzt auf der Startseite sichtbar");
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
    finally { setSavingStats(false); }
  };

  const submitFaq = async (e) => {
    e.preventDefault();
    if (!faqForm.question.trim() || !faqForm.answer.trim()) { toast.error("Frage und Antwort erforderlich"); return; }
    setSavingFaq(true);
    try {
      await axios.post(`${API}/faqs`, faqForm, { withCredentials: true });
      const r = await axios.get(`${API}/faqs`);
      setFaqs(r.data);
      setFaqForm({ question: "", answer: "" });
      toast.success("FAQ hinzugefügt");
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
    finally { setSavingFaq(false); }
  };
  const saveFaqEdit = async (id, question, answer) => {
    try {
      await axios.patch(`${API}/faqs/${id}`, { question, answer }, { withCredentials: true });
      setFaqs((fs) => fs.map((x) => (x.id === id ? { ...x, question, answer } : x)));
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
  };
  const deleteFaq = async (id) => {
    try {
      await axios.delete(`${API}/faqs/${id}`, { withCredentials: true });
      setFaqs((f) => f.filter((x) => x.id !== id));
      toast.success("FAQ gelöscht");
    } catch { toast.error("Löschen fehlgeschlagen"); }
  };

  const submitAppointment = async (e) => {
    e.preventDefault();
    if (!apptForm.title.trim() || !apptForm.date.trim()) { toast.error("Titel und Datum erforderlich"); return; }
    setSavingAppt(true);
    try {
      if (editApptId) {
        await axios.patch(`${API}/appointments/${editApptId}`, apptForm, { withCredentials: true });
      } else {
        await axios.post(`${API}/appointments`, apptForm, { withCredentials: true });
      }
      const r = await axios.get(`${API}/appointments`, { withCredentials: true });
      setAppointments(r.data);
      setApptForm({ title: "", date: "", start: "", end: "", location: "", customer_email: "", note: "" });
      setEditApptId(null);
      toast.success(editApptId ? "Termin angepasst" : "Termin angelegt");
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
    finally { setSavingAppt(false); }
  };
  const startEditAppt = (a) => {
    setEditApptId(a.id);
    setApptForm({ title: a.title || "", date: a.date || "", start: a.start || "", end: a.end || "", location: a.location || "", customer_email: a.customer_email || "", note: a.note || "" });
    document.querySelector('[data-testid="admin-appt-form"]')?.scrollIntoView({ behavior: "smooth", block: "center" });
  };
  const cancelEditAppt = () => { setEditApptId(null); setApptForm({ title: "", date: "", start: "", end: "", location: "", customer_email: "", note: "" }); };
  const deleteAppointment = async (id) => {
    try {
      await axios.delete(`${API}/appointments/${id}`, { withCredentials: true });
      setAppointments((a) => a.filter((x) => x.id !== id));
      toast.success("Termin gelöscht");
    } catch { toast.error("Löschen fehlgeschlagen"); }
  };
  const setApptStatus = async (id, status) => {
    try {
      await axios.patch(`${API}/appointments/${id}/status`, { status }, { withCredentials: true });
      setAppointments((a) => a.map((x) => (x.id === id ? { ...x, status } : x)));
      toast.success(status === "bestaetigt" ? "Termin bestätigt" : status === "storniert" ? "Termin storniert" : "Status aktualisiert");
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
  };

  const submitTeam = async (e) => {
    e.preventDefault();
    setSavingTeam(true);
    try {
      const data = new FormData();
      data.append("name", teamForm.name);
      data.append("role", teamForm.role);
      data.append("contact", teamForm.contact);
      data.append("text", teamForm.text);
      if (teamFile) data.append("file", teamFile);
      const res = await axios.post(`${API}/team`, data, { withCredentials: true });
      setTeam([...team, res.data]);
      setTeamForm({ name: "", role: "", contact: "", text: "" });
      setTeamFile(null);
      e.target.reset();
      toast.success("Mitarbeiter angelegt — jetzt auf der Team-Seite sichtbar");
      refreshPublicTeam();
    } catch (err) {
      toast.error(formatDetail(err.response?.data?.detail));
    } finally {
      setSavingTeam(false);
    }
  };

  const deleteTeamMember = async (id) => {
    try {
      await axios.delete(`${API}/team/${id}`, { withCredentials: true });
      setTeam(team.filter((t) => t.id !== id));
      toast.success("Mitarbeiter entfernt");
      refreshPublicTeam();
    } catch {
      toast.error("Löschen fehlgeschlagen");
    }
  };

  const submitStaff = async (e) => {
    e.preventDefault();
    setSavingStaff(true);
    try {
      const res = await axios.post(`${API}/staff`, staffForm, { withCredentials: true });
      setStaff([res.data, ...staff]);
      setStaffForm({ name: "", email: "", password: "" });
      toast.success("Team-Zugang angelegt");
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
    finally { setSavingStaff(false); }
  };

  const deleteStaff = async (staffEmail) => {
    try {
      await axios.delete(`${API}/staff/${encodeURIComponent(staffEmail)}`, { withCredentials: true });
      setStaff(staff.filter((s) => s.email !== staffEmail));
      toast.success("Team-Zugang entfernt");
    } catch { toast.error("Löschen fehlgeschlagen"); }
  };

  const approveStaff = async (staffEmail) => {
    try {
      await axios.patch(`${API}/staff/${encodeURIComponent(staffEmail)}/approve`, {}, { withCredentials: true });
      setStaff(staff.map((s) => (s.email === staffEmail ? { ...s, approved: true } : s)));
      toast.success("Team-Zugang freigeschaltet");
    } catch { toast.error("Freischalten fehlgeschlagen"); }
  };

  const refreshPublicTeam = () =>
    axios.get(`${API}/team`).then((r) => setPublicTeam(r.data)).catch(() => {});

  const saveMyProfile = async (patch, silent) => {
    try {
      await axios.patch(`${API}/me/profile`, patch, { withCredentials: true });
      setMyProfile((p) => ({ ...p, ...patch }));
      if (!silent) toast.success("Profil gespeichert");
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
  };

  const uploadMyPhoto = async (file) => {
    if (!file) return;
    setSavingMyPhoto(true);
    const data = new FormData(); data.append("file", file);
    try {
      const res = await axios.post(`${API}/me/photo`, data, { withCredentials: true });
      setMyProfile((p) => ({ ...p, photo_path: res.data.photo_path }));
      toast.success("Profilfoto aktualisiert");
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
    finally { setSavingMyPhoto(false); }
  };

  const addMyGallery = async (e) => {
    e.preventDefault();
    const file = e.target.elements.myfile.files[0];
    if (!file) { toast.error("Bitte ein Bild wählen"); return; }
    setSavingMyGallery(true);
    const data = new FormData(); data.append("caption", myCaption); data.append("file", file);
    try {
      const res = await axios.post(`${API}/me/gallery`, data, { withCredentials: true });
      setMyGallery((g) => [...g, res.data]);
      setMyCaption(""); e.target.reset();
      toast.success("Bild hinzugefügt");
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
    finally { setSavingMyGallery(false); }
  };

  const deleteMyGallery = async (id) => {
    try {
      await axios.delete(`${API}/me/gallery/${id}`, { withCredentials: true });
      setMyGallery((g) => g.filter((x) => x.id !== id));
      toast.success("Bild entfernt");
    } catch { toast.error("Löschen fehlgeschlagen"); }
  };

  const moveMyGallery = async (index, dir) => {
    const target = index + dir;
    if (target < 0 || target >= myGallery.length) return;
    const next = [...myGallery];
    [next[index], next[target]] = [next[target], next[index]];
    setMyGallery(next);
    try { await axios.patch(`${API}/me/gallery/reorder`, { ids: next.map((x) => x.id) }, { withCredentials: true }); }
    catch { toast.error("Sortierung fehlgeschlagen"); }
  };

  const saveStaffProfile = async (staffEmail, patch, silent) => {
    try {
      await axios.patch(`${API}/staff/${encodeURIComponent(staffEmail)}/profile`, patch, { withCredentials: true });
      setStaff((prev) => prev.map((s) => (s.email === staffEmail ? { ...s, ...patch } : s)));
      if (!silent) toast.success("Profil aktualisiert");
      refreshPublicTeam();
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
  };

  const setStaffTitleLocal = (staffEmail, title) =>
    setStaff((prev) => prev.map((s) => (s.email === staffEmail ? { ...s, title } : s)));

  const setStaffBioLocal = (staffEmail, bio) =>
    setStaff((prev) => prev.map((s) => (s.email === staffEmail ? { ...s, bio } : s)));

  const uploadStaffPhoto = async (staffEmail, file) => {
    if (!file) return;
    const data = new FormData();
    data.append("file", file);
    try {
      const res = await axios.post(`${API}/staff/${encodeURIComponent(staffEmail)}/photo`, data, { withCredentials: true });
      setStaff((prev) => prev.map((s) => (s.email === staffEmail ? { ...s, photo_path: res.data.photo_path } : s)));
      toast.success("Foto aktualisiert");
      refreshPublicTeam();
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
  };

  const moveTeamCard = async (index, dir) => {
    const target = index + dir;
    if (target < 0 || target >= publicTeam.length) return;
    const next = [...publicTeam];
    [next[index], next[target]] = [next[target], next[index]];
    setPublicTeam(next);
    try {
      await axios.patch(`${API}/team/reorder`, { items: next.map((c) => ({ source: c.source, id: c.id })) }, { withCredentials: true });
    } catch { toast.error("Sortierung fehlgeschlagen"); }
  };

  const resetStaffPassword = async (staffEmail) => {
    const pw = window.prompt(`Neues Passwort für ${staffEmail} (min. 6 Zeichen):`);
    if (!pw) return;
    try {
      await axios.patch(`${API}/staff/${encodeURIComponent(staffEmail)}/password`, { password: pw }, { withCredentials: true });
      toast.success("Passwort aktualisiert");
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
  };

  const submitGallery = async (e) => {
    e.preventDefault();
    if (!galleryFile) { toast.error("Bitte ein Bild wählen"); return; }
    setSavingGallery(true);
    try {
      const data = new FormData();
      data.append("caption", galleryCaption);
      data.append("file", galleryFile);
      const res = await axios.post(`${API}/gallery`, data, { withCredentials: true });
      setGallery([...gallery, res.data]);
      setGalleryCaption(""); setGalleryFile(null); e.target.reset();
      toast.success("Bild zur Galerie hinzugefügt");
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
    finally { setSavingGallery(false); }
  };

  const deleteGalleryItem = async (id) => {
    try {
      await axios.delete(`${API}/gallery/${id}`, { withCredentials: true });
      setGallery(gallery.filter((g) => g.id !== id));
      toast.success("Bild entfernt");
    } catch { toast.error("Löschen fehlgeschlagen"); }
  };

  const moveGallery = async (index, dir) => {
    const target = index + dir;
    if (target < 0 || target >= gallery.length) return;
    const next = [...gallery];
    [next[index], next[target]] = [next[target], next[index]];
    setGallery(next);
    try {
      await axios.patch(`${API}/gallery/reorder`, { ids: next.map((g) => g.id) }, { withCredentials: true });
    } catch { toast.error("Sortierung fehlgeschlagen"); }
  };

  const submitPartner = async (e) => {
    e.preventDefault();
    if (!partnerFile) { toast.error("Bitte ein Logo wählen"); return; }
    if (!partnerForm.name.trim()) { toast.error("Bitte einen Namen eingeben"); return; }
    setSavingPartner(true);
    try {
      const data = new FormData();
      data.append("name", partnerForm.name);
      data.append("website", partnerForm.website);
      data.append("description", partnerForm.description);
      data.append("file", partnerFile);
      const res = await axios.post(`${API}/partners`, data, { withCredentials: true });
      setPartners([...partners, res.data]);
      setPartnerForm({ name: "", website: "", description: "" });
      setPartnerFile(null);
      e.target.reset();
      toast.success("Partner hinzugefügt — jetzt auf der Startseite sichtbar");
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
    finally { setSavingPartner(false); }
  };

  const deletePartner = async (id) => {
    try {
      await axios.delete(`${API}/partners/${id}`, { withCredentials: true });
      setPartners(partners.filter((p) => p.id !== id));
      toast.success("Partner entfernt");
    } catch { toast.error("Löschen fehlgeschlagen"); }
  };

  const movePartner = async (index, dir) => {
    const target = index + dir;
    if (target < 0 || target >= partners.length) return;
    const next = [...partners];
    [next[index], next[target]] = [next[target], next[index]];
    setPartners(next);
    try {
      await axios.patch(`${API}/partners/reorder`, { ids: next.map((p) => p.id) }, { withCredentials: true });
    } catch { toast.error("Sortierung fehlgeschlagen"); }
  };

  const toggleRolePerm = (key) =>
    setRolePerms((cur) => (cur.includes(key) ? cur.filter((k) => k !== key) : [...cur, key]));

  const resetRoleForm = () => { setRoleName(""); setRolePerms([]); setEditingRoleId(null); };

  const submitRole = async (e) => {
    e.preventDefault();
    if (!roleName.trim()) { toast.error("Bitte einen Rollennamen eingeben"); return; }
    setSavingRole(true);
    try {
      const payload = { name: roleName, permissions: rolePerms };
      if (editingRoleId) {
        await axios.patch(`${API}/roles/${editingRoleId}`, payload, { withCredentials: true });
        toast.success("Rolle aktualisiert");
      } else {
        await axios.post(`${API}/roles`, payload, { withCredentials: true });
        toast.success("Rolle angelegt");
      }
      const r = await axios.get(`${API}/roles`, { withCredentials: true });
      setRoles(r.data);
      resetRoleForm();
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
    finally { setSavingRole(false); }
  };

  const editRole = (role) => { setEditingRoleId(role.id); setRoleName(role.name); setRolePerms(role.permissions || []); };

  const deleteRole = async (id) => {
    try {
      await axios.delete(`${API}/roles/${id}`, { withCredentials: true });
      setRoles(roles.filter((r) => r.id !== id));
      if (editingRoleId === id) resetRoleForm();
      const s = await axios.get(`${API}/staff`, { withCredentials: true });
      setStaff(s.data);
      toast.success("Rolle gelöscht");
    } catch { toast.error("Löschen fehlgeschlagen"); }
  };

  const assignStaffRole = async (email, roleId) => {
    try {
      await axios.patch(`${API}/staff/${email}/role`, { role_id: roleId || null }, { withCredentials: true });
      setStaff((cur) => cur.map((s) => (s.email === email ? { ...s, role_id: roleId || null } : s)));
      const r = await axios.get(`${API}/roles`, { withCredentials: true });
      setRoles(r.data);
      toast.success("Rolle zugewiesen");
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
  };

  const submitDocument = async (e) => {
    e.preventDefault();
    if (!docFile) {
      toast.error("Bitte eine PDF-Datei auswählen");
      return;
    }
    setSavingDoc(true);
    try {
      const data = new FormData();
      data.append("einsatz_nr", docForm.einsatz_nr);
      data.append("title", docForm.title);
      data.append("extra_terms", docForm.extra_terms);
      data.append("file", docFile);
      const res = await axios.post(`${API}/documents`, data, { withCredentials: true });
      setDocuments([res.data, ...documents]);
      setDocForm({ einsatz_nr: "", title: "", extra_terms: "" });
      setDocFile(null);
      e.target.reset();
      toast.success(`Dokument geschwärzt & eingebunden (${res.data.pages.length} Seite(n))`);
    } catch (err) {
      toast.error(formatDetail(err.response?.data?.detail));
    } finally {
      setSavingDoc(false);
    }
  };

  const deleteDocument = async (id) => {
    try {
      await axios.delete(`${API}/documents/${id}`, { withCredentials: true });
      setDocuments(documents.filter((d) => d.id !== id));
      toast.success("Dokument entfernt");
    } catch {
      toast.error("Löschen fehlgeschlagen");
    }
  };

  const submitReview = async (e) => {
    e.preventDefault();
    setSavingReview(true);
    try {
      const res = await axios.post(`${API}/reviews`, reviewForm, { withCredentials: true });
      setReviews([...reviews, res.data]);
      setReviewForm({ name: "", role: "", rating: 5, text: "" });
      toast.success("Bewertung veröffentlicht");
    } catch (err) {
      toast.error(formatDetail(err.response?.data?.detail));
    } finally {
      setSavingReview(false);
    }
  };

  const deleteReview = async (id) => {
    try {
      await axios.delete(`${API}/reviews/${id}`, { withCredentials: true });
      setReviews(reviews.filter((r) => r.id !== id));
      toast.success("Bewertung entfernt");
    } catch {
      toast.error("Löschen fehlgeschlagen");
    }
  };

  const submitCustDoc = async (e) => {
    e.preventDefault();
    if (!custDocFile) { toast.error("Bitte eine PDF-Datei wählen"); return; }
    setSavingCustDoc(true);
    try {
      const data = new FormData();
      data.append("customer_email", custDocForm.customer_email);
      data.append("title", custDocForm.title);
      data.append("file", custDocFile);
      const res = await axios.post(`${API}/customer-documents`, data, { withCredentials: true });
      setCustDocs([res.data, ...custDocs]);
      setCustDocForm({ customer_email: "", title: "" });
      setCustDocFile(null);
      e.target.reset();
      toast.success("Dokument für Kunde hochgeladen");
    } catch (err) {
      toast.error(formatDetail(err.response?.data?.detail));
    } finally {
      setSavingCustDoc(false);
    }
  };

  const deleteCustDoc = async (id) => {
    try {
      await axios.delete(`${API}/customer-documents/${id}`, { withCredentials: true });
      setCustDocs(custDocs.filter((d) => d.id !== id));
      toast.success("Dokument entfernt");
    } catch { toast.error("Löschen fehlgeschlagen"); }
  };

  const toggleRequest = async (req) => {
    const done = req.status !== "erledigt";
    try {
      await axios.patch(`${API}/customer-requests/${req.id}`, { done }, { withCredentials: true });
      setCustRequests(custRequests.map((r) => (r.id === req.id ? { ...r, status: done ? "erledigt" : "offen" } : r)));
    } catch { toast.error("Aktualisieren fehlgeschlagen"); }
  };

  const submitOffer = async (e) => {
    e.preventDefault();
    if (!offerFile) { toast.error("Bitte eine PDF-Datei wählen"); return; }
    setSavingOffer(true);
    try {
      const data = new FormData();
      data.append("customer_email", offerForm.customer_email);
      data.append("title", offerForm.title);
      data.append("valid_until", offerForm.valid_until || "");
      data.append("file", offerFile);
      const res = await axios.post(`${API}/offers`, data, { withCredentials: true });
      setOffers([res.data, ...offers]);
      setOfferForm({ customer_email: "", title: "", valid_until: "" });
      setOfferFile(null);
      e.target.reset();
      toast.success("Angebot hochgeladen");
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
    finally { setSavingOffer(false); }
  };

  const deleteOffer = async (id) => {
    try {
      await axios.delete(`${API}/offers/${id}`, { withCredentials: true });
      setOffers(offers.filter((o) => o.id !== id));
      toast.success("Angebot entfernt");
    } catch { toast.error("Löschen fehlgeschlagen"); }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      if (res.data.role === "customer") {
        toast.error("Dies ist der Team-/Admin-Bereich. Bitte im Kundenportal anmelden.");
        return;
      }
      setUser(res.data);
      toast.success("Angemeldet — willkommen zurück");
    } catch (err) {
      toast.error(formatDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/staff/register`, { name: regName, email, password }, { withCredentials: true });
      toast.success("Registrierung eingegangen — ein Admin schaltet dich frei, sobald geprüft wurde.");
      setAuthMode("login");
      setRegName(""); setPassword("");
    } catch (err) {
      toast.error(formatDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const changePassword = async (e) => {
    e.preventDefault();
    if (pwForm.next !== pwForm.confirm) { toast.error("Die neuen Passwörter stimmen nicht überein"); return; }
    if (pwForm.next.length < 8) { toast.error("Neues Passwort muss mindestens 8 Zeichen haben"); return; }
    setSavingPw(true);
    try {
      await axios.post(`${API}/auth/change-password`, { current_password: pwForm.current, new_password: pwForm.next }, { withCredentials: true });
      toast.success("Passwort geändert — bitte beim nächsten Login das neue Passwort verwenden");
      setPwForm({ current: "", next: "", confirm: "" });
    } catch (err) { toast.error(formatDetail(err.response?.data?.detail)); }
    finally { setSavingPw(false); }
  };

  const handleLogout = async () => {    await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    setUser(false);
    setEnquiries([]);
  };

  const toggleDone = async (item) => {
    try {
      await axios.patch(`${API}/enquiries/${item.id}/done`, { done: !item.done }, { withCredentials: true });
      setEnquiries(enquiries.map((x) => (x.id === item.id ? { ...x, done: !item.done } : x)));
    } catch {
      toast.error("Status konnte nicht gespeichert werden");
    }
  };

  const openCount = enquiries.filter((e) => !e.done).length;
  const isAdmin = user && user.role === "admin";
  const perms = (user && user.permissions) || [];
  const can = (area) => isAdmin || perms.includes(area);
  const cardsSC = showcaseItems.filter((s) => s.type === "card");
  const docsSC = showcaseItems.filter((s) => s.type === "doc");
  const tabDefs = [
    { id: "anfragen", label: "ANFRAGEN", show: can("enquiries") },
    { id: "einsaetze", label: "EINSÄTZE", show: can("missions") },
    { id: "dokumentation", label: "DOKUMENTATION", show: can("documents") },
    { id: "galerie", label: "GALERIE", show: can("gallery") },
    { id: "bewertungen", label: "BEWERTUNGEN", show: can("reviews") },
    { id: "kundenportal", label: "KUNDENPORTAL", show: can("customers") || can("offers") },
    { id: "kunden", label: "KUNDEN", show: can("customers") },
    { id: "support", label: "SUPPORT", show: can("customers") },
    { id: "bilder", label: "BILDER", show: can("gallery") },
    { id: "livechat", label: "LIVE-CHAT", show: can("customers"), badge: chatUnread },
    { id: "kalender", label: "KALENDER", show: can("customers") },
    { id: "team", label: "TEAM & ROLLEN", show: isAdmin || (user && user.role === "team") },
    { id: "partner", label: "PARTNER", show: isAdmin },
    { id: "statistik", label: "STATISTIK", show: isAdmin },
    { id: "faq", label: "FAQ", show: isAdmin },
    { id: "protokoll", label: "PROTOKOLL", show: isAdmin },
  ];
  const visibleTabs = tabDefs.filter((t) => t.show);

  useEffect(() => {
    if (user && visibleTabs.length && !visibleTabs.find((t) => t.id === activeTab)) {
      setActiveTab(visibleTabs[0].id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <div className="min-h-screen bg-[#09090B] text-white selection:bg-[#F5B301] selection:text-black">
      <div className="grain" aria-hidden="true" />
      <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-black/50 backdrop-blur-xl">
        <div className="flex items-center justify-between px-6 py-4 lg:px-16">
          <a href="/" data-testid="admin-logo" className="flex items-center gap-3">
            <img src="/assets/logo.png" alt="DROPS TFR Wappen" className="h-10 w-10 object-contain" />
            <span className="font-display text-lg font-black uppercase tracking-tighter">
              Drops<span className="text-[#F5B301]"> TFR</span>
              <span className="ml-3 font-tac text-[10px] font-normal tracking-[0.3em] text-white/40">{user && user.role === "team" ? "TEAM" : "ADMIN"}</span>
            </span>
          </a>
          {user && (
            <div className="flex items-center gap-4">
              <span data-testid="admin-current-role" className="hidden font-tac text-[10px] tracking-[0.25em] text-white/40 sm:inline">{user.name} · {user.role === "team" ? "TEAM" : "ADMIN"}</span>
              <button
                data-testid="admin-logout-button"
                onClick={handleLogout}
                className="group flex items-center gap-2 font-tac text-xs tracking-[0.2em] text-white/70 transition-colors duration-300 hover:text-white"
              >
                <LogOut className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
                ABMELDEN
              </button>
            </div>
          )}
        </div>
      </header>

      <main className="mx-auto max-w-5xl px-6 pb-32 pt-36" data-testid="admin-page">
        {user === null ? (
          <div className="flex justify-center pt-20">
            <Loader2 className="h-6 w-6 animate-spin text-[#F5B301]" />
          </div>
        ) : !user ? (
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="mx-auto max-w-md"
          >
            <div className="border border-white/15 p-10">
              <span className="flex h-11 w-11 items-center justify-center border border-[#F5B301]">
                <Lock className="h-5 w-5 text-[#F5B301]" />
              </span>
              <h1 className="mt-8 font-display text-3xl font-black uppercase tracking-tighter">
                {authMode === "register" ? "Team-Registrierung" : "Einsatzleitung"}
              </h1>
              <p className="mt-3 font-tac text-xs leading-relaxed text-[#A1A1AA]">
                {authMode === "register"
                  ? "Registriere dich als Team-Mitglied. Dein Zugang wird nach Prüfung durch einen Admin freigeschaltet."
                  : "Geschützter Bereich. Bitte mit den Admin- oder Team-Zugangsdaten anmelden."}
              </p>
              <form data-testid={authMode === "register" ? "admin-register-form" : "admin-login-form"} onSubmit={authMode === "register" ? handleRegister : handleLogin} className="mt-9 flex flex-col gap-7">
                {authMode === "register" && (
                  <label className="group block">
                    <span className="font-tac text-[10px] uppercase tracking-[0.3em] text-white/50 transition-colors duration-300 group-focus-within:text-[#F5B301]">
                      Name
                    </span>
                    <input
                      data-testid="admin-register-name"
                      type="text"
                      required
                      value={regName}
                      onChange={(e) => setRegName(e.target.value)}
                      className="mt-2 w-full border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white focus:border-[#F5B301] focus:outline-none"
                    />
                  </label>
                )}
                <label className="group block">
                  <span className="font-tac text-[10px] uppercase tracking-[0.3em] text-white/50 transition-colors duration-300 group-focus-within:text-[#F5B301]">
                    E-Mail
                  </span>
                  <input
                    data-testid="admin-input-email"
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="mt-2 w-full border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white focus:border-[#F5B301] focus:outline-none"
                  />
                </label>
                <label className="group block">
                  <span className="font-tac text-[10px] uppercase tracking-[0.3em] text-white/50 transition-colors duration-300 group-focus-within:text-[#F5B301]">
                    Passwort{authMode === "register" ? " (min. 6 Zeichen)" : ""}
                  </span>
                  <input
                    data-testid="admin-input-password"
                    type="password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="mt-2 w-full border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white focus:border-[#F5B301] focus:outline-none"
                  />
                </label>
                <button
                  data-testid={authMode === "register" ? "admin-register-button" : "admin-login-button"}
                  type="submit"
                  disabled={loading}
                  className="group relative mt-2 overflow-hidden bg-[#F5B301] px-8 py-4 font-tac text-xs font-bold tracking-[0.25em] text-black transition-transform duration-300 hover:scale-[1.02] active:scale-[0.98] disabled:opacity-60"
                >
                  <span className="relative z-10 flex items-center justify-center gap-3">
                    {loading && <Loader2 className="h-4 w-4 animate-spin" />}
                    {loading ? (authMode === "register" ? "SENDE ..." : "PRÜFE ...") : (authMode === "register" ? "REGISTRIEREN" : "ANMELDEN")}
                  </span>
                </button>
              </form>
              <button
                type="button"
                data-testid="admin-auth-toggle"
                onClick={() => { setAuthMode(authMode === "register" ? "login" : "register"); setPassword(""); }}
                className="mt-6 w-full text-center font-tac text-[10px] tracking-[0.2em] text-white/40 transition-colors hover:text-[#F5B301]"
              >
                {authMode === "register" ? "← ZURÜCK ZUM LOGIN" : "NEU IM TEAM? ALS TEAM REGISTRIEREN →"}
              </button>
            </div>
          </motion.div>
        ) : (
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          >
            <p className="font-tac text-xs tracking-[0.3em] text-[#F5B301]">EINSATZLEITUNG</p>
            <h1 className="mt-4 font-display text-4xl font-black uppercase tracking-tighter sm:text-5xl">Admin-Bereich</h1>
            <div data-testid="admin-tabs" className="mt-8 flex flex-wrap gap-1 border-b border-white/10">
              {visibleTabs.map((t) => (
                <button
                  key={t.id}
                  data-testid={`admin-tab-${t.id}`}
                  onClick={() => setActiveTab(t.id)}
                  className={`-mb-px border-b-2 px-4 py-3 font-tac text-[11px] tracking-[0.2em] transition-colors ${activeTab === t.id ? "border-[#F5B301] text-[#F5B301]" : "border-transparent text-white/50 hover:text-white"}`}
                >
                  <span className="flex items-center gap-1.5">{t.label}{t.badge > 0 && <span className="bg-[#F5B301] px-1.5 py-0.5 text-[9px] font-bold text-black">{t.badge}</span>}</span>
                </button>
              ))}
            </div>

            {activeTab === "anfragen" && can("enquiries") && (<>
            <div className="mt-10 flex flex-wrap items-end justify-between gap-4">
              <h2 className="font-display text-3xl font-black uppercase tracking-tighter">
                Anfragen
              </h2>
              <p data-testid="admin-stats" className="font-tac text-xs tracking-[0.25em] text-white/50">
                OFFEN: <span className="text-[#F5B301]">{openCount}</span> // GESAMT: {enquiries.length}
              </p>
            </div>

            <div className="mt-12 border-t border-white/10">
              {enquiries.length === 0 ? (
                <p className="py-16 text-center font-tac text-xs tracking-[0.25em] text-white/40">
                  KEINE ANFRAGEN VORHANDEN
                </p>
              ) : (
                enquiries.map((item) => (
                  <div
                    key={item.id}
                    data-testid={`admin-enquiry-${item.id}`}
                    className={`grid grid-cols-12 items-start gap-4 border-b border-white/10 py-6 transition-opacity duration-300 ${item.done ? "opacity-40" : ""}`}
                  >
                    <button
                      data-testid={`admin-done-toggle-${item.id}`}
                      onClick={() => toggleDone(item)}
                      aria-label={item.done ? "Als offen markieren" : "Als erledigt markieren"}
                      className={`col-span-2 mt-1 flex h-6 w-6 items-center justify-center border transition-colors duration-300 sm:col-span-1 ${
                        item.done ? "border-[#F5B301] bg-[#F5B301]" : "border-white/30 hover:border-[#F5B301]"
                      }`}
                    >
                      {item.done && <Check className="h-4 w-4 text-black" />}
                    </button>
                    <div className="col-span-10 sm:col-span-3">
                      <p className={`font-tac text-sm font-bold text-white ${item.done ? "line-through" : ""}`}>
                        {item.name}
                      </p>
                      {item.organisation && (
                        <p className="mt-1 font-tac text-xs text-white/50">{item.organisation}</p>
                      )}
                      <a
                        href={`mailto:${item.email}`}
                        className="mt-1 block font-tac text-xs text-[#F5B301] transition-opacity duration-300 hover:opacity-70"
                      >
                        {item.email}
                      </a>
                    </div>
                    <p className="col-span-10 col-start-3 font-tac text-xs leading-relaxed text-[#A1A1AA] sm:col-span-6 sm:col-start-auto">
                      {item.message}
                    </p>
                    <p className="col-span-10 col-start-3 font-tac text-[10px] tracking-[0.2em] text-white/40 sm:col-span-2 sm:col-start-auto sm:text-right">
                      {new Date(item.timestamp).toLocaleDateString("de-DE", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })}
                    </p>
                  </div>
                ))
              )}
            </div>
            </>)}

            {activeTab === "einsaetze" && can("missions") && (
            <div className="mt-20 border-t border-white/10 pt-14">
              <p className="font-tac text-xs tracking-[0.3em] text-[#F5B301]">EINSATZLOG</p>
              <h2 className="mt-4 font-display text-3xl font-black uppercase tracking-tighter">
                Einsatz eintragen
              </h2>
              <form data-testid="admin-mission-form" onSubmit={submitMission} className="mt-8 grid gap-7 sm:grid-cols-2">
                <label className="group block">
                  <span className="font-tac text-[10px] uppercase tracking-[0.3em] text-white/50 transition-colors duration-300 group-focus-within:text-[#F5B301]">
                    Einsatz-Nr *
                  </span>
                  <input
                    data-testid="admin-mission-nr"
                    type="text"
                    required
                    placeholder="2026-000063"
                    value={missionForm.nr}
                    onChange={(e) => setMissionForm({ ...missionForm, nr: e.target.value })}
                    className="mt-2 w-full border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none"
                  />
                </label>
                <label className="group block">
                  <span className="font-tac text-[10px] uppercase tracking-[0.3em] text-white/50 transition-colors duration-300 group-focus-within:text-[#F5B301]">
                    Datum
                  </span>
                  <input
                    data-testid="admin-mission-datum"
                    type="text"
                    placeholder="14.08.2026"
                    value={missionForm.datum}
                    onChange={(e) => setMissionForm({ ...missionForm, datum: e.target.value })}
                    className="mt-2 w-full border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none"
                  />
                </label>
                <label className="group block sm:col-span-2">
                  <span className="font-tac text-[10px] uppercase tracking-[0.3em] text-white/50 transition-colors duration-300 group-focus-within:text-[#F5B301]">
                    Einsatz-Titel *
                  </span>
                  <input
                    data-testid="admin-mission-title"
                    type="text"
                    required
                    placeholder="Dachinspektion Gewerbehalle"
                    value={missionForm.title}
                    onChange={(e) => setMissionForm({ ...missionForm, title: e.target.value })}
                    className="mt-2 w-full border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none"
                  />
                </label>
                <label className="group block">
                  <span className="font-tac text-[10px] uppercase tracking-[0.3em] text-white/50 transition-colors duration-300 group-focus-within:text-[#F5B301]">
                    Ort
                  </span>
                  <input
                    data-testid="admin-mission-ort"
                    type="text"
                    placeholder="Herne"
                    value={missionForm.ort}
                    onChange={(e) => setMissionForm({ ...missionForm, ort: e.target.value })}
                    className="mt-2 w-full border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none"
                  />
                </label>
                <label className="group block">
                  <span className="font-tac text-[10px] uppercase tracking-[0.3em] text-white/50 transition-colors duration-300 group-focus-within:text-[#F5B301]">
                    Foto *
                  </span>
                  <input
                    data-testid="admin-mission-file"
                    type="file"
                    required
                    accept="image/*"
                    onChange={(e) => setMissionFile(e.target.files[0] || null)}
                    className="mt-2 w-full border-b border-white/20 bg-transparent py-3 font-tac text-xs text-white/60 file:mr-4 file:border file:border-[#F5B301] file:bg-transparent file:px-4 file:py-2 file:font-tac file:text-[10px] file:tracking-[0.2em] file:text-[#F5B301] focus:border-[#F5B301] focus:outline-none"
                  />
                </label>
                <div className="sm:col-span-2">
                  <button
                    data-testid="admin-mission-submit"
                    type="submit"
                    disabled={savingMission}
                    className="group relative overflow-hidden bg-[#F5B301] px-8 py-4 font-tac text-xs font-bold tracking-[0.25em] text-black transition-transform duration-300 hover:scale-[1.02] active:scale-[0.98] disabled:opacity-60"
                  >
                    <span className="relative z-10 flex items-center gap-3">
                      {savingMission && <Loader2 className="h-4 w-4 animate-spin" />}
                      {savingMission ? "WIRD HOCHGLADEN ..." : "EINSATZ SPEICHERN"}
                    </span>
                  </button>
                </div>
              </form>

              {missions.length > 0 && (
                <div className="mt-12 border-t border-white/10">
                  {missions.map((m) => { const cover = m.cover_path || m.image_path; return (
                    <div
                      key={m.id}
                      data-testid={`admin-mission-${m.id}`}
                      className="grid grid-cols-12 items-center gap-4 border-b border-white/10 py-4"
                    >
                      <div className="relative col-span-3 sm:col-span-1">
                        <img
                          src={`${BACKEND}/api/mission-image/${m.image_path}`}
                          alt={m.title}
                          className={`h-14 w-full border object-cover ${cover === m.image_path ? "border-[#F5B301]" : "border-white/10"}`}
                        />
                        <button
                          data-testid={`admin-mission-cover-main-${m.id}`}
                          onClick={() => setMissionCover(m.id, m.image_path)}
                          title="Als Titelbild"
                          className={`absolute -right-1.5 -top-1.5 flex h-5 w-5 items-center justify-center border ${cover === m.image_path ? "border-[#F5B301] bg-[#F5B301] text-black" : "border-white/30 bg-black/80 text-white/70 hover:text-[#F5B301]"}`}
                        >
                          <Star className="h-3 w-3" fill={cover === m.image_path ? "currentColor" : "none"} />
                        </button>
                      </div>
                      <span className="col-span-4 font-tac text-xs tracking-[0.15em] text-[#F5B301] sm:col-span-2">
                        {m.nr}
                      </span>
                      <span className="col-span-9 font-display text-sm font-black uppercase text-white sm:col-span-6">
                        {m.title}
                      </span>
                      <span className="hidden font-tac text-xs text-white/50 sm:col-span-2 sm:block">
                        {m.ort}
                      </span>
                      <div className="col-span-12 flex justify-end gap-3 sm:col-span-1">
                        <button data-testid={`admin-mission-edit-${m.id}`} onClick={() => setEditMission(editMission?.id === m.id ? null : { id: m.id, nr: m.nr, title: m.title, ort: m.ort || "", datum: m.datum || "", status: m.status || "" })} aria-label={`Einsatz ${m.nr} bearbeiten`} className="text-white/40 transition-colors duration-300 hover:text-[#F5B301]"><Pencil className="h-4 w-4" /></button>
                        <button data-testid={`admin-mission-delete-${m.id}`} onClick={() => deleteMission(m.id)} aria-label={`Einsatz ${m.nr} löschen`} className="text-white/40 transition-colors duration-300 hover:text-red-400"><Trash2 className="h-4 w-4" /></button>
                      </div>
                      <div className="col-span-12 flex flex-wrap items-center gap-2 border-t border-white/5 pt-3">
                        <span className="font-tac text-[9px] uppercase tracking-[0.25em] text-white/40">Galerie:</span>
                        {(m.gallery || []).map((g) => (
                          <div key={g.id} data-testid={`admin-mission-gallery-${g.id}`} className="relative">
                            <img src={`${BACKEND}/api/mission-image/${g.storage_path}`} alt="" className={`h-12 w-12 border object-cover ${cover === g.storage_path ? "border-[#F5B301]" : "border-white/15"}`} />
                            <button data-testid={`admin-mission-cover-${g.id}`} onClick={() => setMissionCover(m.id, g.storage_path)} title="Als Titelbild" className={`absolute -left-1.5 -top-1.5 flex h-5 w-5 items-center justify-center border ${cover === g.storage_path ? "border-[#F5B301] bg-[#F5B301] text-black" : "border-white/30 bg-black/80 text-white/70 hover:text-[#F5B301]"}`}><Star className="h-3 w-3" fill={cover === g.storage_path ? "currentColor" : "none"} /></button>
                            <button data-testid={`admin-mission-gallery-delete-${g.id}`} onClick={() => deleteMissionGallery(g.id)} aria-label="Bild löschen" className="absolute -right-1.5 -top-1.5 flex h-5 w-5 items-center justify-center bg-black/80 text-white/70 hover:text-red-400"><Trash2 className="h-3 w-3" /></button>
                          </div>
                        ))}
                        <label className="flex h-12 w-12 cursor-pointer items-center justify-center border border-dashed border-white/25 text-[#F5B301] hover:border-[#F5B301]">
                          <ImageIcon className="h-4 w-4" />
                          <input data-testid={`admin-mission-gallery-add-${m.id}`} type="file" accept="image/*" className="hidden" onChange={(e) => uploadMissionGallery(m.id, e.target.files[0])} />
                        </label>
                      </div>
                      {editMission?.id === m.id && (
                        <form data-testid={`admin-mission-edit-form-${m.id}`} onSubmit={saveEditMission} className="col-span-12 mt-3 grid gap-3 border-t border-white/10 pt-4 sm:grid-cols-6">
                          <input data-testid={`admin-mission-edit-nr-${m.id}`} value={editMission.nr} onChange={(e) => setEditMission({ ...editMission, nr: e.target.value })} placeholder="Nr" className="border-b border-white/20 bg-transparent py-2 font-tac text-xs text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none" />
                          <input data-testid={`admin-mission-edit-title-${m.id}`} value={editMission.title} onChange={(e) => setEditMission({ ...editMission, title: e.target.value })} placeholder="Titel" className="border-b border-white/20 bg-transparent py-2 font-tac text-xs text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none sm:col-span-2" />
                          <input data-testid={`admin-mission-edit-ort-${m.id}`} value={editMission.ort} onChange={(e) => setEditMission({ ...editMission, ort: e.target.value })} placeholder="Ort" className="border-b border-white/20 bg-transparent py-2 font-tac text-xs text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none" />
                          <input data-testid={`admin-mission-edit-datum-${m.id}`} value={editMission.datum} onChange={(e) => setEditMission({ ...editMission, datum: e.target.value })} placeholder="Datum" className="border-b border-white/20 bg-transparent py-2 font-tac text-xs text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none" />
                          <input data-testid={`admin-mission-edit-status-${m.id}`} value={editMission.status} onChange={(e) => setEditMission({ ...editMission, status: e.target.value })} placeholder="Status (z. B. in Bearbeitung)" className="border-b border-white/20 bg-transparent py-2 font-tac text-xs text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none" />
                          <label className="sm:col-span-3 flex items-center gap-2 font-tac text-[10px] tracking-[0.15em] text-white/50">
                            FOTO ERSETZEN:
                            <input data-testid={`admin-mission-edit-file-${m.id}`} type="file" accept="image/*" onChange={(e) => setEditMission({ ...editMission, _file: e.target.files[0] || null })} className="font-tac text-[10px] text-white/60 file:mr-2 file:border file:border-[#F5B301] file:bg-transparent file:px-2 file:py-1 file:text-[9px] file:text-[#F5B301]" />
                          </label>
                          <div className="sm:col-span-3 flex items-center gap-4">
                            <button data-testid={`admin-mission-edit-save-${m.id}`} type="submit" disabled={savingEditMission} className="flex items-center gap-2 bg-[#F5B301] px-6 py-2.5 font-tac text-[10px] font-bold tracking-[0.2em] text-black disabled:opacity-60">{savingEditMission && <Loader2 className="h-3 w-3 animate-spin" />} SPEICHERN</button>
                            <button type="button" onClick={() => setEditMission(null)} className="font-tac text-[10px] tracking-[0.2em] text-white/50 hover:text-[#F5B301]">ABBRECHEN</button>
                          </div>
                        </form>
                      )}
                    </div>
                  ); })}
                </div>
              )}

              <div className="mt-16 border-t border-white/10 pt-10">
                <h3 className="flex items-center gap-2 font-tac text-[11px] tracking-[0.3em] text-[#F5B301]"><ImageIcon className="h-3.5 w-3.5" /> REFERENZ-KARTEN (STARTSEITE REFERENZEN)</h3>
                <p className="mt-2 font-tac text-[11px] text-white/40">Große Referenz-Karten mit Bild + Text auf der Referenzen-Seite. Bild ersetzbar, Text direkt editierbar.</p>
                <form data-testid="admin-card-form" onSubmit={submitCard} className="mt-6 grid gap-3 sm:grid-cols-4">
                  <input data-testid="admin-card-title" placeholder="Titel" value={cardForm.title} onChange={(e) => setCardForm({ ...cardForm, title: e.target.value })} className="border-b border-white/20 bg-transparent py-2 font-tac text-xs text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none" />
                  <input data-testid="admin-card-meta" placeholder="Meta (z. B. INSPEKTION // ENERGIE)" value={cardForm.meta} onChange={(e) => setCardForm({ ...cardForm, meta: e.target.value })} className="border-b border-white/20 bg-transparent py-2 font-tac text-xs text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none" />
                  <input data-testid="admin-card-text" placeholder="Beschreibung" value={cardForm.text} onChange={(e) => setCardForm({ ...cardForm, text: e.target.value })} className="border-b border-white/20 bg-transparent py-2 font-tac text-xs text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none" />
                  <input data-testid="admin-card-file" type="file" required accept="image/*" onChange={(e) => setCardFile(e.target.files[0] || null)} className="border-b border-white/20 bg-transparent py-2 font-tac text-[10px] text-white/60 file:mr-2 file:border file:border-[#F5B301] file:bg-transparent file:px-2 file:py-1 file:text-[9px] file:text-[#F5B301]" />
                  <div className="sm:col-span-4"><button data-testid="admin-card-submit" type="submit" disabled={savingShowcase} className="flex items-center gap-2 bg-[#F5B301] px-6 py-2.5 font-tac text-[10px] font-bold tracking-[0.2em] text-black disabled:opacity-60">{savingShowcase && <Loader2 className="h-3 w-3 animate-spin" />} KARTE HINZUFÜGEN</button></div>
                </form>
                <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="admin-card-list">
                  {cardsSC.map((c) => (
                    <div key={c.id} data-testid={`admin-card-${c.id}`} className="border border-white/10">
                      <div className="relative">
                        <img src={`${BACKEND}/api/showcase-image/${c.image_path}`} alt={c.title} className="aspect-[16/10] w-full object-cover" />
                        <label className="absolute bottom-1.5 right-1.5 cursor-pointer bg-black/70 px-2 py-1 font-tac text-[9px] tracking-[0.15em] text-[#F5B301] hover:bg-black/90">FOTO ERSETZEN<input data-testid={`admin-card-replace-${c.id}`} type="file" accept="image/*" className="hidden" onChange={(e) => replaceShowcaseImage(c.id, e.target.files[0])} /></label>
                      </div>
                      <div className="space-y-2 p-3">
                        <input defaultValue={c.title} onBlur={(e) => saveShowcaseText(c.id, { title: e.target.value })} className="w-full border-b border-white/15 bg-transparent py-1 font-tac text-xs font-bold text-white focus:border-[#F5B301] focus:outline-none" />
                        <input defaultValue={c.meta} onBlur={(e) => saveShowcaseText(c.id, { meta: e.target.value })} className="w-full border-b border-white/15 bg-transparent py-1 font-tac text-[10px] text-[#F5B301] focus:border-[#F5B301] focus:outline-none" />
                        <textarea defaultValue={c.text} onBlur={(e) => saveShowcaseText(c.id, { text: e.target.value })} rows={2} className="w-full border-b border-white/15 bg-transparent py-1 font-tac text-[10px] text-white/60 focus:border-[#F5B301] focus:outline-none" />
                        <button data-testid={`admin-card-delete-${c.id}`} onClick={() => deleteShowcase(c.id)} className="flex items-center gap-1 font-tac text-[9px] tracking-[0.2em] text-white/40 hover:text-red-400"><Trash2 className="h-3 w-3" /> LÖSCHEN</button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            )}

            {activeTab === "team" && user.role === "team" && myProfile && (
            <div className="mt-4 border-t border-white/10 pt-14" data-testid="my-profile-section">
              <p className="flex items-center gap-2 font-tac text-xs tracking-[0.3em] text-[#F5B301]">
                <Users className="h-4 w-4" /> MEIN PROFIL
              </p>
              <h2 className="mt-4 font-display text-3xl font-black uppercase tracking-tighter">Web-Profil bearbeiten</h2>
              <p className="mt-3 max-w-xl font-tac text-xs leading-relaxed text-[#A1A1AA]">
                Gestalte dein öffentliches Profil. Ob es auf der Team-Seite erscheint, gibt der Admin frei. Status: {myProfile.public ? <span className="text-emerald-400">öffentlich sichtbar</span> : <span className="text-amber-400">noch nicht freigegeben</span>}.
              </p>
              <div className="mt-8 flex flex-wrap items-start gap-6">
                {myProfile.photo_path ? (
                  <img src={`${BACKEND}/api/team-image/${myProfile.photo_path}`} alt={myProfile.name} className="h-28 w-28 border border-white/15 object-cover" />
                ) : (
                  <span className="flex h-28 w-28 items-center justify-center border border-white/15 font-display text-xl font-black text-white/25">{(myProfile.name || "?").slice(0, 2).toUpperCase()}</span>
                )}
                <label className="cursor-pointer border border-white/20 px-4 py-3 font-tac text-[10px] tracking-[0.2em] text-white/70 hover:border-[#F5B301] hover:text-[#F5B301]">
                  {savingMyPhoto ? "LÄDT ..." : "PROFILFOTO WÄHLEN"}
                  <input data-testid="my-photo-input" type="file" accept="image/*" className="hidden" onChange={(e) => uploadMyPhoto(e.target.files[0])} />
                </label>
              </div>
              <div className="mt-8 grid max-w-2xl gap-5 sm:grid-cols-2">
                <input data-testid="my-title-input" placeholder="Funktion (z. B. Fernpilot)" value={myProfile.title || ""} onChange={(e) => setMyProfile((p) => ({ ...p, title: e.target.value }))} onBlur={(e) => saveMyProfile({ title: e.target.value }, true)} className="border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none" />
                <input data-testid="my-bio-input" placeholder="Kurzprofil" value={myProfile.bio || ""} onChange={(e) => setMyProfile((p) => ({ ...p, bio: e.target.value }))} onBlur={(e) => saveMyProfile({ bio: e.target.value }, true)} className="border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none" />
              </div>

              <h3 className="mt-12 font-tac text-[10px] tracking-[0.3em] text-white/40">MEINE GALERIE</h3>
              <form data-testid="my-gallery-form" onSubmit={addMyGallery} className="mt-4 grid gap-5 sm:grid-cols-3">
                <input data-testid="my-gallery-caption" placeholder="Bildunterschrift (optional)" value={myCaption} onChange={(e) => setMyCaption(e.target.value)} className="border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none" />
                <input data-testid="my-gallery-file" name="myfile" type="file" required accept="image/*" className="border-b border-white/20 bg-transparent py-3 font-tac text-xs text-white/60 file:mr-3 file:border file:border-[#F5B301] file:bg-transparent file:px-3 file:py-1.5 file:text-[10px] file:text-[#F5B301]" />
                <div><button data-testid="my-gallery-submit" type="submit" disabled={savingMyGallery} className="flex items-center gap-2 bg-[#F5B301] px-8 py-4 font-tac text-xs font-bold tracking-[0.25em] text-black disabled:opacity-60">{savingMyGallery && <Loader2 className="h-4 w-4 animate-spin" />} HOCHLADEN</button></div>
              </form>
              {myGallery.length > 0 && (
                <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="my-gallery-list">
                  {myGallery.map((g, i) => (
                    <div key={g.id} data-testid={`my-gallery-${g.id}`} className="overflow-hidden border border-white/10">
                      <img src={`${BACKEND}/api/member-image/${g.storage_path}`} alt={g.caption || "Bild"} className="aspect-[4/3] w-full object-cover" />
                      <div className="flex items-center justify-between gap-2 border-t border-white/10 bg-black/40 p-3">
                        <span className="truncate font-tac text-[10px] text-white/60">#{i + 1} {g.caption || ""}</span>
                        <div className="flex items-center gap-1.5">
                          <button data-testid={`my-gallery-up-${g.id}`} onClick={() => moveMyGallery(i, -1)} disabled={i === 0} className="text-white/50 hover:text-[#F5B301] disabled:opacity-30"><ChevronUp className="h-4 w-4" /></button>
                          <button data-testid={`my-gallery-down-${g.id}`} onClick={() => moveMyGallery(i, 1)} disabled={i === myGallery.length - 1} className="text-white/50 hover:text-[#F5B301] disabled:opacity-30"><ChevronDown className="h-4 w-4" /></button>
                          <button data-testid={`my-gallery-delete-${g.id}`} onClick={() => deleteMyGallery(g.id)} className="text-white/40 hover:text-red-400"><Trash2 className="h-4 w-4" /></button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            )}

            {activeTab === "team" && isAdmin && (
            <div className="mt-20 border-t border-white/10 pt-14" data-testid="admin-security-section">
              <p className="flex items-center gap-2 font-tac text-xs tracking-[0.3em] text-[#F5B301]">
                <Lock className="h-4 w-4" /> SICHERHEIT
              </p>
              <h2 className="mt-4 font-display text-3xl font-black uppercase tracking-tighter">
                Admin-Passwort ändern
              </h2>
              <p className="mt-3 max-w-xl font-tac text-xs leading-relaxed text-[#A1A1AA]">
                Lege ein eigenes, sicheres Passwort fest. Es bleibt auch nach Updates erhalten und wird nicht mehr überschrieben.
              </p>
              <form data-testid="admin-password-form" onSubmit={changePassword} className="mt-8 grid max-w-2xl gap-5 sm:grid-cols-3">
                <input data-testid="admin-password-current" type="password" required placeholder="Aktuelles Passwort" value={pwForm.current} onChange={(e) => setPwForm({ ...pwForm, current: e.target.value })} className="border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none" />
                <input data-testid="admin-password-new" type="password" required placeholder="Neues Passwort (min. 8)" value={pwForm.next} onChange={(e) => setPwForm({ ...pwForm, next: e.target.value })} className="border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none" />
                <input data-testid="admin-password-confirm" type="password" required placeholder="Neues Passwort bestätigen" value={pwForm.confirm} onChange={(e) => setPwForm({ ...pwForm, confirm: e.target.value })} className="border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none" />
                <div className="sm:col-span-3">
                  <button data-testid="admin-password-submit" type="submit" disabled={savingPw} className="flex items-center gap-2 bg-[#F5B301] px-8 py-4 font-tac text-xs font-bold tracking-[0.25em] text-black disabled:opacity-60">
                    {savingPw && <Loader2 className="h-4 w-4 animate-spin" />} PASSWORT ÄNDERN
                  </button>
                </div>
              </form>
            </div>
            )}

            {activeTab === "team" && isAdmin && (
            <div className="mt-20 border-t border-white/10 pt-14">
              <p className="flex items-center gap-2 font-tac text-xs tracking-[0.3em] text-[#F5B301]">
                <Users className="h-4 w-4" /> TEAM
              </p>
              <h2 className="mt-4 font-display text-3xl font-black uppercase tracking-tighter">
                Mitarbeiter anlegen
              </h2>
              <form data-testid="admin-team-form" onSubmit={submitTeam} className="mt-8 grid gap-7 sm:grid-cols-2">
                <label className="group block">
                  <span className="font-tac text-[10px] uppercase tracking-[0.3em] text-white/50 transition-colors duration-300 group-focus-within:text-[#F5B301]">
                    Name *
                  </span>
                  <input
                    data-testid="admin-team-name"
                    type="text"
                    required
                    placeholder="Daniel Schäfer"
                    value={teamForm.name}
                    onChange={(e) => setTeamForm({ ...teamForm, name: e.target.value })}
                    className="mt-2 w-full border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none"
                  />
                </label>
                <label className="group block">
                  <span className="font-tac text-[10px] uppercase tracking-[0.3em] text-white/50 transition-colors duration-300 group-focus-within:text-[#F5B301]">
                    Funktion *
                  </span>
                  <input
                    data-testid="admin-team-role"
                    type="text"
                    required
                    placeholder="Geschäftsführung & Pilot"
                    value={teamForm.role}
                    onChange={(e) => setTeamForm({ ...teamForm, role: e.target.value })}
                    className="mt-2 w-full border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none"
                  />
                </label>
                <label className="group block">
                  <span className="font-tac text-[10px] uppercase tracking-[0.3em] text-white/50 transition-colors duration-300 group-focus-within:text-[#F5B301]">
                    Kontakt (E-Mail / Telefon)
                  </span>
                  <input
                    data-testid="admin-team-contact"
                    type="text"
                    placeholder="daniel@drohnen-ops.de"
                    value={teamForm.contact}
                    onChange={(e) => setTeamForm({ ...teamForm, contact: e.target.value })}
                    className="mt-2 w-full border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none"
                  />
                </label>
                <label className="group block">
                  <span className="font-tac text-[10px] uppercase tracking-[0.3em] text-white/50 transition-colors duration-300 group-focus-within:text-[#F5B301]">
                    Foto (optional)
                  </span>
                  <input
                    data-testid="admin-team-file"
                    type="file"
                    accept="image/*"
                    onChange={(e) => setTeamFile(e.target.files[0] || null)}
                    className="mt-2 w-full border-b border-white/20 bg-transparent py-3 font-tac text-xs text-white/60 file:mr-4 file:border file:border-[#F5B301] file:bg-transparent file:px-4 file:py-2 file:font-tac file:text-[10px] file:tracking-[0.2em] file:text-[#F5B301] focus:border-[#F5B301] focus:outline-none"
                  />
                </label>
                <label className="group block sm:col-span-2">
                  <span className="font-tac text-[10px] uppercase tracking-[0.3em] text-white/50 transition-colors duration-300 group-focus-within:text-[#F5B301]">
                    Kurztext (optional)
                  </span>
                  <textarea
                    data-testid="admin-team-text"
                    rows={2}
                    placeholder="Kurze Beschreibung / Schwerpunkt"
                    value={teamForm.text}
                    onChange={(e) => setTeamForm({ ...teamForm, text: e.target.value })}
                    className="mt-2 w-full resize-none border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none"
                  />
                </label>
                <div className="sm:col-span-2">
                  <button
                    data-testid="admin-team-submit"
                    type="submit"
                    disabled={savingTeam}
                    className="group relative overflow-hidden bg-[#F5B301] px-8 py-4 font-tac text-xs font-bold tracking-[0.25em] text-black transition-transform duration-300 hover:scale-[1.02] active:scale-[0.98] disabled:opacity-60"
                  >
                    <span className="relative z-10 flex items-center gap-3">
                      {savingTeam && <Loader2 className="h-4 w-4 animate-spin" />}
                      {savingTeam ? "WIRD GESPEICHERT ..." : "MITARBEITER SPEICHERN"}
                    </span>
                  </button>
                </div>
              </form>

              {team.length > 0 && (
                <div className="mt-12 border-t border-white/10">
                  {team.map((t) => (
                    <div
                      key={t.id}
                      data-testid={`admin-team-${t.id}`}
                      className="grid grid-cols-12 items-center gap-4 border-b border-white/10 py-4"
                    >
                      {t.image_path ? (
                        <img
                          src={`${BACKEND}/api/team-image/${t.image_path}`}
                          alt={t.name}
                          className="col-span-3 h-14 w-14 border border-white/10 object-cover sm:col-span-1"
                        />
                      ) : (
                        <span className="col-span-3 flex h-14 w-14 items-center justify-center border border-white/10 font-display text-lg font-black text-white/30 sm:col-span-1">
                          {(t.name || "?").slice(0, 1)}
                        </span>
                      )}
                      <span className="col-span-9 font-display text-sm font-black uppercase text-white sm:col-span-4">
                        {t.name}
                      </span>
                      <span className="col-span-8 font-tac text-xs tracking-[0.15em] text-[#F5B301] sm:col-span-3">
                        {t.role}
                      </span>
                      <span className="hidden font-tac text-xs text-white/50 sm:col-span-3 sm:block">
                        {t.contact}
                      </span>
                      <button
                        data-testid={`admin-team-delete-${t.id}`}
                        onClick={() => deleteTeamMember(t.id)}
                        aria-label={`${t.name} löschen`}
                        className="col-span-4 flex justify-end text-white/40 transition-colors duration-300 hover:text-[#F5B301] sm:col-span-1"
                      >
                        <Trash2 className="h-4 w-4" />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
            )}

            {activeTab === "team" && isAdmin && (
            <div className="mt-20 border-t border-white/10 pt-14" data-testid="admin-roles-section">
              <p className="flex items-center gap-2 font-tac text-xs tracking-[0.3em] text-[#F5B301]">
                <Lock className="h-4 w-4" /> ROLLEN & RECHTE
              </p>
              <h2 className="mt-4 font-display text-3xl font-black uppercase tracking-tighter">
                {editingRoleId ? "Rolle bearbeiten" : "Rolle anlegen"}
              </h2>
              <p className="mt-3 max-w-xl font-tac text-xs leading-relaxed text-[#A1A1AA]">
                Lege eigene Team-Rollen an und wähle, welche Bereiche ein Mitglied verwalten darf. Weise die Rolle unten unter „TEAM-ZUGÄNGE" zu. Ein Mitglied ohne Rolle hat vollen Zugriff.
              </p>
              <form data-testid="admin-role-form" onSubmit={submitRole} className="mt-8 max-w-3xl">
                <input data-testid="admin-role-name" placeholder="Rollenname (z. B. Nur Galerie)" value={roleName} onChange={(e) => setRoleName(e.target.value)} className="w-full border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none sm:max-w-md" />
                <div className="mt-6 flex flex-wrap gap-3">
                  {permAreas.map((a) => {
                    const active = rolePerms.includes(a.key);
                    return (
                      <button type="button" key={a.key} data-testid={`admin-role-perm-${a.key}`} onClick={() => toggleRolePerm(a.key)}
                        className={`flex items-center gap-2 border px-4 py-2.5 font-tac text-[11px] tracking-[0.15em] transition-colors ${active ? "border-[#F5B301] bg-[#F5B301]/10 text-[#F5B301]" : "border-white/20 text-white/50 hover:border-white/50"}`}>
                        <span className={`flex h-4 w-4 items-center justify-center border ${active ? "border-[#F5B301] bg-[#F5B301]" : "border-white/30"}`}>{active && <Check className="h-3 w-3 text-black" />}</span>
                        {a.label}
                      </button>
                    );
                  })}
                </div>
                <div className="mt-8 flex items-center gap-4">
                  <button data-testid="admin-role-submit" type="submit" disabled={savingRole} className="flex items-center gap-2 bg-[#F5B301] px-8 py-4 font-tac text-xs font-bold tracking-[0.25em] text-black disabled:opacity-60">
                    {savingRole && <Loader2 className="h-4 w-4 animate-spin" />} {editingRoleId ? "ROLLE SPEICHERN" : "ROLLE ANLEGEN"}
                  </button>
                  {editingRoleId && (
                    <button type="button" data-testid="admin-role-cancel" onClick={resetRoleForm} className="font-tac text-[10px] tracking-[0.2em] text-white/50 hover:text-[#F5B301]">ABBRECHEN</button>
                  )}
                </div>
              </form>
              {roles.length > 0 && (
                <div className="mt-10 grid gap-4 sm:grid-cols-2" data-testid="admin-role-list">
                  {roles.map((r) => (
                    <div key={r.id} data-testid={`admin-role-${r.id}`} className="border border-white/10 bg-white/[0.02] p-5">
                      <div className="flex items-start justify-between gap-3">
                        <div>
                          <p className="font-display text-lg font-black uppercase tracking-tight text-white">{r.name}</p>
                          <p className="mt-1 font-tac text-[10px] tracking-[0.2em] text-white/40">{r.member_count || 0} MITGLIED(ER)</p>
                        </div>
                        <div className="flex items-center gap-3">
                          <button data-testid={`admin-role-edit-${r.id}`} onClick={() => editRole(r)} className="font-tac text-[10px] tracking-[0.2em] text-white/50 hover:text-[#F5B301]">BEARBEITEN</button>
                          <button data-testid={`admin-role-delete-${r.id}`} onClick={() => deleteRole(r.id)} aria-label="Rolle löschen" className="text-white/40 hover:text-red-400"><Trash2 className="h-4 w-4" /></button>
                        </div>
                      </div>
                      <div className="mt-4 flex flex-wrap gap-2">
                        {(r.permissions || []).length === 0 ? (
                          <span className="font-tac text-[10px] text-white/30">Keine Bereiche</span>
                        ) : (r.permissions || []).map((p) => (
                          <span key={p} className="border border-[#F5B301]/30 px-2 py-1 font-tac text-[9px] tracking-[0.2em] text-[#F5B301]">{(permAreas.find((a) => a.key === p) || {}).label || p}</span>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            )}

            {activeTab === "team" && isAdmin && (
            <div className="mt-20 border-t border-white/10 pt-14">
              <p className="flex items-center gap-2 font-tac text-xs tracking-[0.3em] text-[#F5B301]">
                <Lock className="h-4 w-4" /> TEAM-ZUGÄNGE
              </p>
              <h2 className="mt-4 font-display text-3xl font-black uppercase tracking-tighter">
                Team-Login anlegen
              </h2>
              <p className="mt-3 max-w-xl font-tac text-xs leading-relaxed text-[#A1A1AA]">
                Lege Zugänge für dein Team an. Team-Mitglieder können Anfragen, Einsätze, Dokumente und Angebote verwalten — jedoch keine Team-Mitglieder anlegen/löschen und keine Passwörter ändern.
              </p>
              <form data-testid="admin-staff-form" onSubmit={submitStaff} className="mt-8 grid gap-5 sm:grid-cols-3">
                <input data-testid="admin-staff-name" required placeholder="Name" value={staffForm.name} onChange={(e) => setStaffForm({ ...staffForm, name: e.target.value })} className="border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none" />
                <input data-testid="admin-staff-email" required type="email" placeholder="team@drops-tfr.de" value={staffForm.email} onChange={(e) => setStaffForm({ ...staffForm, email: e.target.value })} className="border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none" />
                <input data-testid="admin-staff-password" required type="text" placeholder="Passwort (min. 6 Zeichen)" value={staffForm.password} onChange={(e) => setStaffForm({ ...staffForm, password: e.target.value })} className="border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none" />
                <div className="sm:col-span-3">
                  <button data-testid="admin-staff-submit" type="submit" disabled={savingStaff} className="flex items-center gap-2 bg-[#F5B301] px-8 py-4 font-tac text-xs font-bold tracking-[0.25em] text-black disabled:opacity-60">
                    {savingStaff && <Loader2 className="h-4 w-4 animate-spin" />} TEAM-ZUGANG ANLEGEN
                  </button>
                </div>
              </form>
              {staff.length > 0 && (
                <div className="mt-6 border-t border-white/10" data-testid="admin-staff-list">
                  {staff.map((s) => (
                    <div key={s.email} data-testid={`admin-staff-${s.email}`} className="border-b border-white/10 py-4">
                      <div className="grid grid-cols-12 items-center gap-4">
                        <span className="col-span-6 font-tac text-sm text-white sm:col-span-3">{s.name}</span>
                        <span className="col-span-6 font-tac text-xs text-[#F5B301] sm:col-span-4">{s.email}</span>
                        <span className={`col-span-6 font-tac text-[9px] tracking-[0.2em] sm:col-span-2 ${s.approved === false ? "text-amber-400" : "text-emerald-400"}`}>
                          {s.approved === false ? "● AUSSTEHEND" : "● FREIGESCHALTET"}
                        </span>
                        <div className="col-span-6 flex justify-end gap-4 sm:col-span-3">
                          {s.approved === false && (
                            <button data-testid={`admin-staff-approve-${s.email}`} onClick={() => approveStaff(s.email)} className="font-tac text-[10px] font-bold tracking-[0.2em] text-emerald-400 hover:text-emerald-300">FREISCHALTEN</button>
                          )}
                          <button data-testid={`admin-staff-reset-${s.email}`} onClick={() => resetStaffPassword(s.email)} className="font-tac text-[10px] tracking-[0.2em] text-white/50 hover:text-[#F5B301]">PASSWORT</button>
                          <button data-testid={`admin-staff-delete-${s.email}`} onClick={() => deleteStaff(s.email)} aria-label="Team-Zugang löschen" className="text-white/40 hover:text-red-400"><Trash2 className="h-4 w-4" /></button>
                        </div>
                      </div>
                      {s.approved !== false && (
                        <div className="mt-4 flex flex-wrap items-center gap-4 border-t border-white/5 pt-4">
                          <div className="flex items-center gap-3">
                            {s.photo_path ? (
                              <img src={`${BACKEND}/api/team-image/${s.photo_path}`} alt={s.name} className="h-12 w-12 border border-white/15 object-cover" />
                            ) : (
                              <span className="flex h-12 w-12 items-center justify-center border border-white/15 font-display text-sm font-black text-white/25">{(s.name || "?").slice(0, 2).toUpperCase()}</span>
                            )}
                            <label className="cursor-pointer font-tac text-[10px] tracking-[0.2em] text-white/50 hover:text-[#F5B301]">
                              FOTO
                              <input data-testid={`admin-staff-photo-${s.email}`} type="file" accept="image/*" className="hidden" onChange={(e) => uploadStaffPhoto(s.email, e.target.files[0])} />
                            </label>
                          </div>
                          <input
                            data-testid={`admin-staff-title-${s.email}`}
                            placeholder="Funktion (z. B. Fernpilot)"
                            value={s.title || ""}
                            onChange={(e) => setStaffTitleLocal(s.email, e.target.value)}
                            onBlur={(e) => saveStaffProfile(s.email, { title: e.target.value }, true)}
                            className="min-w-[150px] flex-1 border-b border-white/20 bg-transparent py-2 font-tac text-xs text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none"
                          />
                          <input
                            data-testid={`admin-staff-bio-${s.email}`}
                            placeholder="Kurzprofil (optional, erscheint auf der Karte)"
                            value={s.bio || ""}
                            onChange={(e) => setStaffBioLocal(s.email, e.target.value)}
                            onBlur={(e) => saveStaffProfile(s.email, { bio: e.target.value }, true)}
                            className="min-w-[200px] flex-1 border-b border-white/20 bg-transparent py-2 font-tac text-xs text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none"
                          />
                          <button
                            data-testid={`admin-staff-public-${s.email}`}
                            onClick={() => saveStaffProfile(s.email, { public: !s.public })}
                            className={`flex items-center gap-2 border px-3 py-2 font-tac text-[10px] tracking-[0.2em] transition-colors ${s.public ? "border-emerald-400/50 text-emerald-400" : "border-white/20 text-white/50 hover:border-[#F5B301] hover:text-[#F5B301]"}`}
                          >
                            {s.public ? <Eye className="h-3.5 w-3.5" /> : <EyeOff className="h-3.5 w-3.5" />}
                            {s.public ? "AUF WEBSITE: AN" : "AUF WEBSITE: AUS"}
                          </button>
                          <select
                            data-testid={`admin-staff-role-${s.email}`}
                            value={s.role_id || ""}
                            onChange={(e) => assignStaffRole(s.email, e.target.value)}
                            className="border border-white/20 bg-transparent px-3 py-2 font-tac text-[10px] tracking-[0.15em] text-white/70 focus:border-[#F5B301] focus:outline-none [&>option]:bg-[#09090B]"
                          >
                            <option value="">VOLLER ZUGRIFF (KEINE ROLLE)</option>
                            {roles.map((r) => (
                              <option key={r.id} value={r.id}>{r.name}</option>
                            ))}
                          </select>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
            )}

            {activeTab === "team" && isAdmin && publicTeam.length > 0 && (
            <div className="mt-20 border-t border-white/10 pt-14" data-testid="admin-team-order-section">
              <p className="flex items-center gap-2 font-tac text-xs tracking-[0.3em] text-[#F5B301]">
                <Users className="h-4 w-4" /> TEAM-REIHENFOLGE (WEBSITE)
              </p>
              <h2 className="mt-4 font-display text-3xl font-black uppercase tracking-tighter">
                Anzeigereihenfolge
              </h2>
              <p className="mt-3 max-w-xl font-tac text-xs leading-relaxed text-[#A1A1AA]">
                Bestimme die Reihenfolge aller Karten auf der öffentlichen Team-Seite (Mitarbeiter und freigeschaltete Team-Logins) per Hoch/Runter.
              </p>
              <div className="mt-8" data-testid="admin-team-order-list">
                {publicTeam.map((c, i) => (
                  <div key={`${c.source}-${c.id}`} data-testid={`admin-team-order-${c.source}-${c.id}`} className="grid grid-cols-12 items-center gap-4 border-b border-white/10 py-4">
                    <span className="col-span-1 font-tac text-[10px] tracking-[0.2em] text-[#F5B301]">#{i + 1}</span>
                    <div className="col-span-8 flex items-center gap-3 sm:col-span-9">
                      {c.image_path ? (
                        <img src={`${BACKEND}/api/team-image/${c.image_path}`} alt={c.name} className="h-10 w-10 border border-white/15 object-cover" />
                      ) : (
                        <span className="flex h-10 w-10 items-center justify-center border border-white/15 font-display text-[10px] font-black text-white/25">{(c.name || "?").slice(0, 2).toUpperCase()}</span>
                      )}
                      <div>
                        <p className="font-tac text-sm text-white">{c.name}</p>
                        <p className="font-tac text-[9px] uppercase tracking-[0.25em] text-white/40">{c.role} · {c.source === "staff" ? "Team-Login" : "Mitarbeiter"}</p>
                      </div>
                    </div>
                    <div className="col-span-3 flex justify-end gap-1.5 sm:col-span-2">
                      <button data-testid={`admin-team-up-${c.source}-${c.id}`} onClick={() => moveTeamCard(i, -1)} disabled={i === 0} aria-label="Nach oben" className="text-white/50 hover:text-[#F5B301] disabled:opacity-30"><ChevronUp className="h-4 w-4" /></button>
                      <button data-testid={`admin-team-down-${c.source}-${c.id}`} onClick={() => moveTeamCard(i, 1)} disabled={i === publicTeam.length - 1} aria-label="Nach unten" className="text-white/50 hover:text-[#F5B301] disabled:opacity-30"><ChevronDown className="h-4 w-4" /></button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            )}

            {activeTab === "galerie" && can("gallery") && (
            <div className="mt-20 border-t border-white/10 pt-14">
              <p className="flex items-center gap-2 font-tac text-xs tracking-[0.3em] text-[#F5B301]">
                <ImageIcon className="h-4 w-4" /> BILDERGALERIE
              </p>
              <h2 className="mt-4 font-display text-3xl font-black uppercase tracking-tighter">
                Galerie verwalten
              </h2>
              <p className="mt-3 max-w-xl font-tac text-xs leading-relaxed text-[#A1A1AA]">
                Lade eigene Bilder für die Galerie auf der Team-Seite hoch und bestimme die Reihenfolge. Die Galerie ist öffentlich unter /team sichtbar.
              </p>
              <form data-testid="admin-gallery-form" onSubmit={submitGallery} className="mt-8 grid gap-5 sm:grid-cols-3">
                <input data-testid="admin-gallery-caption" placeholder="Bildunterschrift (optional)" value={galleryCaption} onChange={(e) => setGalleryCaption(e.target.value)} className="border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none sm:col-span-1" />
                <input data-testid="admin-gallery-file" type="file" required accept="image/*" onChange={(e) => setGalleryFile(e.target.files[0] || null)} className="border-b border-white/20 bg-transparent py-3 font-tac text-xs text-white/60 file:mr-3 file:border file:border-[#F5B301] file:bg-transparent file:px-3 file:py-1.5 file:text-[10px] file:text-[#F5B301] sm:col-span-1" />
                <div className="sm:col-span-1">
                  <button data-testid="admin-gallery-submit" type="submit" disabled={savingGallery} className="flex items-center gap-2 bg-[#F5B301] px-8 py-4 font-tac text-xs font-bold tracking-[0.25em] text-black disabled:opacity-60">
                    {savingGallery && <Loader2 className="h-4 w-4 animate-spin" />} BILD HOCHLADEN
                  </button>
                </div>
              </form>
              {gallery.length > 0 && (
                <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="admin-gallery-list">
                  {gallery.map((g, i) => (
                    <div key={g.id} data-testid={`admin-gallery-${g.id}`} className="group relative overflow-hidden border border-white/10">
                      <img src={`${BACKEND}/api/gallery-image/${g.storage_path}`} alt={g.caption || "Galeriebild"} className="aspect-[4/3] w-full object-cover" />
                      <div className="flex items-center justify-between gap-2 border-t border-white/10 bg-black/40 p-3">
                        <span className="truncate font-tac text-[10px] text-white/60">{g.caption || "—"}</span>
                        <div className="flex items-center gap-1.5">
                          <button data-testid={`admin-gallery-up-${g.id}`} onClick={() => moveGallery(i, -1)} disabled={i === 0} aria-label="Nach oben" className="text-white/50 hover:text-[#F5B301] disabled:opacity-30"><ChevronUp className="h-4 w-4" /></button>
                          <button data-testid={`admin-gallery-down-${g.id}`} onClick={() => moveGallery(i, 1)} disabled={i === gallery.length - 1} aria-label="Nach unten" className="text-white/50 hover:text-[#F5B301] disabled:opacity-30"><ChevronDown className="h-4 w-4" /></button>
                          <button data-testid={`admin-gallery-delete-${g.id}`} onClick={() => deleteGalleryItem(g.id)} aria-label="Bild löschen" className="text-white/40 hover:text-red-400"><Trash2 className="h-4 w-4" /></button>
                        </div>
                      </div>
                      <span className="absolute left-2 top-2 bg-black/60 px-2 py-0.5 font-tac text-[9px] tracking-[0.2em] text-[#F5B301]">#{i + 1}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
            )}

            {activeTab === "partner" && isAdmin && (
            <div className="mt-20 border-t border-white/10 pt-14" data-testid="admin-partners-section">
              <p className="flex items-center gap-2 font-tac text-xs tracking-[0.3em] text-[#F5B301]">
                <Handshake className="h-4 w-4" /> KOOPERATIONSPARTNER
              </p>
              <h2 className="mt-4 font-display text-3xl font-black uppercase tracking-tighter">
                Partner-Banner
              </h2>
              <p className="mt-3 max-w-xl font-tac text-xs leading-relaxed text-[#A1A1AA]">
                Lade Partner-Logos hoch (Name, Website-Link und kurze Beschreibung). Sie erscheinen als Logo-Laufband oben auf der Startseite. Ein Klick öffnet die Partner-Website.
              </p>
              <form data-testid="admin-partner-form" onSubmit={submitPartner} className="mt-8 grid gap-5 sm:grid-cols-2">
                <input data-testid="admin-partner-name" placeholder="Name*" value={partnerForm.name} onChange={(e) => setPartnerForm({ ...partnerForm, name: e.target.value })} className="border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none" />
                <input data-testid="admin-partner-website" placeholder="Website-Link (optional)" value={partnerForm.website} onChange={(e) => setPartnerForm({ ...partnerForm, website: e.target.value })} className="border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none" />
                <input data-testid="admin-partner-description" placeholder="Kurze Beschreibung (optional)" value={partnerForm.description} onChange={(e) => setPartnerForm({ ...partnerForm, description: e.target.value })} className="border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none sm:col-span-2" />
                <input data-testid="admin-partner-file" type="file" required accept="image/*" onChange={(e) => setPartnerFile(e.target.files[0] || null)} className="border-b border-white/20 bg-transparent py-3 font-tac text-xs text-white/60 file:mr-3 file:border file:border-[#F5B301] file:bg-transparent file:px-3 file:py-1.5 file:text-[10px] file:text-[#F5B301]" />
                <div>
                  <button data-testid="admin-partner-submit" type="submit" disabled={savingPartner} className="flex items-center gap-2 bg-[#F5B301] px-8 py-4 font-tac text-xs font-bold tracking-[0.25em] text-black disabled:opacity-60">
                    {savingPartner && <Loader2 className="h-4 w-4 animate-spin" />} PARTNER HINZUFÜGEN
                  </button>
                </div>
              </form>
              {partners.length > 0 && (
                <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="admin-partner-list">
                  {partners.map((p, i) => (
                    <div key={p.id} data-testid={`admin-partner-${p.id}`} className="group relative overflow-hidden border border-white/10">
                      <div className="flex h-28 items-center justify-center bg-white/5 p-4">
                        <img src={`${BACKEND}/api/partner-image/${p.logo_path}`} alt={p.name} className="max-h-full max-w-full object-contain" />
                      </div>
                      <div className="border-t border-white/10 bg-black/40 p-3">
                        <div className="flex items-center justify-between gap-2">
                          <span className="truncate font-tac text-xs font-bold text-white/80">{p.name}</span>
                          <div className="flex items-center gap-1.5">
                            <button data-testid={`admin-partner-up-${p.id}`} onClick={() => movePartner(i, -1)} disabled={i === 0} aria-label="Nach oben" className="text-white/50 hover:text-[#F5B301] disabled:opacity-30"><ChevronUp className="h-4 w-4" /></button>
                            <button data-testid={`admin-partner-down-${p.id}`} onClick={() => movePartner(i, 1)} disabled={i === partners.length - 1} aria-label="Nach unten" className="text-white/50 hover:text-[#F5B301] disabled:opacity-30"><ChevronDown className="h-4 w-4" /></button>
                            <button data-testid={`admin-partner-delete-${p.id}`} onClick={() => deletePartner(p.id)} aria-label="Partner löschen" className="text-white/40 hover:text-red-400"><Trash2 className="h-4 w-4" /></button>
                          </div>
                        </div>
                        {p.website && <span className="mt-1 block truncate font-tac text-[10px] text-[#F5B301]">{p.website}</span>}
                        {p.description && <span className="mt-1 block truncate font-tac text-[10px] text-white/40">{p.description}</span>}
                      </div>
                      <span className="absolute left-2 top-2 bg-black/60 px-2 py-0.5 font-tac text-[9px] tracking-[0.2em] text-[#F5B301]">#{i + 1}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
            )}


            {activeTab === "dokumentation" && can("documents") && (
            <div className="mt-20 border-t border-white/10 pt-14">
              <p className="flex items-center gap-2 font-tac text-xs tracking-[0.3em] text-[#F5B301]">
                <FileText className="h-4 w-4" /> EINSATZ-DOKUMENTATION
              </p>
              <h2 className="mt-4 font-display text-3xl font-black uppercase tracking-tighter">
                PDF hochladen & schwärzen
              </h2>
              <p className="mt-3 max-w-xl font-tac text-xs leading-relaxed text-[#A1A1AA]">
                Lade ein Einsatz-PDF hoch. Personenbezogene Daten (Kunde, Adresse,
                Bearbeiter, Personalnummer, Kontakt, Unterschrift) werden automatisch
                geschwärzt. Jede Seite wird als Bild in die öffentliche Dokumentation
                übernommen — die Original-PDF wird nicht gespeichert.
              </p>
              <form data-testid="admin-doc-form" onSubmit={submitDocument} className="mt-8 grid gap-7 sm:grid-cols-2">
                <label className="group block">
                  <span className="font-tac text-[10px] uppercase tracking-[0.3em] text-white/50 transition-colors duration-300 group-focus-within:text-[#F5B301]">
                    Einsatz-Nr *
                  </span>
                  <input
                    data-testid="admin-doc-nr"
                    type="text"
                    required
                    placeholder="2026-000050"
                    value={docForm.einsatz_nr}
                    onChange={(e) => setDocForm({ ...docForm, einsatz_nr: e.target.value })}
                    className="mt-2 w-full border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none"
                  />
                </label>
                <label className="group block">
                  <span className="font-tac text-[10px] uppercase tracking-[0.3em] text-white/50 transition-colors duration-300 group-focus-within:text-[#F5B301]">
                    Titel *
                  </span>
                  <input
                    data-testid="admin-doc-title"
                    type="text"
                    required
                    placeholder="Anfahrtsbericht"
                    value={docForm.title}
                    onChange={(e) => setDocForm({ ...docForm, title: e.target.value })}
                    className="mt-2 w-full border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none"
                  />
                </label>
                <label className="group block sm:col-span-2">
                  <span className="font-tac text-[10px] uppercase tracking-[0.3em] text-white/50 transition-colors duration-300 group-focus-within:text-[#F5B301]">
                    Zusätzliche Begriffe schwärzen (optional, mit Komma trennen)
                  </span>
                  <input
                    data-testid="admin-doc-terms"
                    type="text"
                    placeholder="Max Mustermann, Beispielweg 1, 0170 1234567"
                    value={docForm.extra_terms}
                    onChange={(e) => setDocForm({ ...docForm, extra_terms: e.target.value })}
                    className="mt-2 w-full border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none"
                  />
                </label>
                <label className="group block sm:col-span-2">
                  <span className="font-tac text-[10px] uppercase tracking-[0.3em] text-white/50 transition-colors duration-300 group-focus-within:text-[#F5B301]">
                    PDF-Datei *
                  </span>
                  <input
                    data-testid="admin-doc-file"
                    type="file"
                    required
                    accept="application/pdf,.pdf"
                    onChange={(e) => setDocFile(e.target.files[0] || null)}
                    className="mt-2 w-full border-b border-white/20 bg-transparent py-3 font-tac text-xs text-white/60 file:mr-4 file:border file:border-[#F5B301] file:bg-transparent file:px-4 file:py-2 file:font-tac file:text-[10px] file:tracking-[0.2em] file:text-[#F5B301] focus:border-[#F5B301] focus:outline-none"
                  />
                </label>
                <div className="sm:col-span-2">
                  <button
                    data-testid="admin-doc-submit"
                    type="submit"
                    disabled={savingDoc}
                    className="group relative overflow-hidden bg-[#F5B301] px-8 py-4 font-tac text-xs font-bold tracking-[0.25em] text-black transition-transform duration-300 hover:scale-[1.02] active:scale-[0.98] disabled:opacity-60"
                  >
                    <span className="relative z-10 flex items-center gap-3">
                      {savingDoc && <Loader2 className="h-4 w-4 animate-spin" />}
                      {savingDoc ? "WIRD GESCHWÄRZT ..." : "HOCHLADEN & SCHWÄRZEN"}
                    </span>
                  </button>
                </div>
              </form>

              {documents.length > 0 && (
                <div className="mt-12 border-t border-white/10">
                  {documents.map((d) => (
                    <div
                      key={d.id}
                      data-testid={`admin-doc-${d.id}`}
                      className="grid grid-cols-12 items-center gap-4 border-b border-white/10 py-4"
                    >
                      <img
                        src={`${BACKEND}/api/document-image/${d.pages[0]}`}
                        alt={d.title}
                        className="col-span-3 h-16 w-full border border-white/10 object-cover object-top sm:col-span-1"
                      />
                      <span className="col-span-9 font-display text-sm font-black uppercase text-white sm:col-span-4">
                        {d.title}
                      </span>
                      <span className="col-span-6 font-tac text-xs tracking-[0.15em] text-[#F5B301] sm:col-span-3">
                        {d.einsatz_nr}
                      </span>
                      <span className="col-span-4 font-tac text-xs text-white/50 sm:col-span-3">
                        {d.pages.length} Seite(n)
                      </span>
                      <button
                        data-testid={`admin-doc-delete-${d.id}`}
                        onClick={() => deleteDocument(d.id)}
                        aria-label={`Dokument ${d.title} löschen`}
                        className="col-span-2 flex justify-end text-white/40 transition-colors duration-300 hover:text-[#F5B301] sm:col-span-1"
                      >
                        <Trash2 className="h-4 w-4" />
                      </button>
                    </div>
                  ))}
                </div>
              )}

              <div className="mt-16 border-t border-white/10 pt-10">
                <h3 className="flex items-center gap-2 font-tac text-[11px] tracking-[0.3em] text-[#F5B301]"><ImageIcon className="h-3.5 w-3.5" /> DOKUMENT-BILDER (STARTSEITE REFERENZEN)</h3>
                <p className="mt-2 font-tac text-[11px] text-white/40">Feste Beispiel-Dokumente auf der Referenzen-Seite. Bild ersetzbar, Text editierbar, löschbar.</p>
                <form data-testid="admin-scdoc-form" onSubmit={submitDoc2} className="mt-6 grid gap-3 sm:grid-cols-3">
                  <input data-testid="admin-scdoc-title" placeholder="Titel" value={docForm2.title} onChange={(e) => setDocForm2({ ...docForm2, title: e.target.value })} className="border-b border-white/20 bg-transparent py-2 font-tac text-xs text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none" />
                  <input data-testid="admin-scdoc-meta" placeholder="Meta (z. B. STAMMDATEN · SOP)" value={docForm2.meta} onChange={(e) => setDocForm2({ ...docForm2, meta: e.target.value })} className="border-b border-white/20 bg-transparent py-2 font-tac text-xs text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none" />
                  <input data-testid="admin-scdoc-file" type="file" required accept="image/*" onChange={(e) => setDocFile2(e.target.files[0] || null)} className="border-b border-white/20 bg-transparent py-2 font-tac text-[10px] text-white/60 file:mr-2 file:border file:border-[#F5B301] file:bg-transparent file:px-2 file:py-1 file:text-[9px] file:text-[#F5B301]" />
                  <div className="sm:col-span-3"><button data-testid="admin-scdoc-submit" type="submit" disabled={savingShowcase} className="flex items-center gap-2 bg-[#F5B301] px-6 py-2.5 font-tac text-[10px] font-bold tracking-[0.2em] text-black disabled:opacity-60">{savingShowcase && <Loader2 className="h-3 w-3 animate-spin" />} DOKUMENT-BILD HINZUFÜGEN</button></div>
                </form>
                <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-testid="admin-scdoc-list">
                  {docsSC.map((d) => (
                    <div key={d.id} data-testid={`admin-scdoc-${d.id}`} className="border border-white/10">
                      <div className="relative">
                        <img src={`${BACKEND}/api/showcase-image/${d.image_path}`} alt={d.title} className="aspect-[3/4] w-full bg-white object-cover object-top" />
                        <label className="absolute bottom-1.5 right-1.5 cursor-pointer bg-black/70 px-2 py-1 font-tac text-[9px] tracking-[0.15em] text-[#F5B301] hover:bg-black/90">ERSETZEN<input data-testid={`admin-scdoc-replace-${d.id}`} type="file" accept="image/*" className="hidden" onChange={(e) => replaceShowcaseImage(d.id, e.target.files[0])} /></label>
                      </div>
                      <div className="space-y-2 p-3">
                        <input defaultValue={d.title} onBlur={(e) => saveShowcaseText(d.id, { title: e.target.value })} className="w-full border-b border-white/15 bg-transparent py-1 font-tac text-xs font-bold text-white focus:border-[#F5B301] focus:outline-none" />
                        <input defaultValue={d.meta} onBlur={(e) => saveShowcaseText(d.id, { meta: e.target.value })} className="w-full border-b border-white/15 bg-transparent py-1 font-tac text-[10px] text-white/50 focus:border-[#F5B301] focus:outline-none" />
                        <button data-testid={`admin-scdoc-delete-${d.id}`} onClick={() => deleteShowcase(d.id)} className="flex items-center gap-1 font-tac text-[9px] tracking-[0.2em] text-white/40 hover:text-red-400"><Trash2 className="h-3 w-3" /> LÖSCHEN</button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            )}

            {activeTab === "bewertungen" && can("reviews") && (
            <div className="mt-20 border-t border-white/10 pt-14">
              <p className="flex items-center gap-2 font-tac text-xs tracking-[0.3em] text-[#F5B301]">
                <Star className="h-4 w-4" /> KUNDENBEWERTUNGEN
              </p>
              <h2 className="mt-4 font-display text-3xl font-black uppercase tracking-tighter">
                Bewertung hinzufügen
              </h2>
              <form data-testid="admin-review-form" onSubmit={submitReview} className="mt-8 grid gap-7 sm:grid-cols-2">
                <label className="group block">
                  <span className="font-tac text-[10px] uppercase tracking-[0.3em] text-white/50 transition-colors duration-300 group-focus-within:text-[#F5B301]">
                    Name *
                  </span>
                  <input
                    data-testid="admin-review-name"
                    type="text"
                    required
                    placeholder="Andrea Vogt"
                    value={reviewForm.name}
                    onChange={(e) => setReviewForm({ ...reviewForm, name: e.target.value })}
                    className="mt-2 w-full border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none"
                  />
                </label>
                <label className="group block">
                  <span className="font-tac text-[10px] uppercase tracking-[0.3em] text-white/50 transition-colors duration-300 group-focus-within:text-[#F5B301]">
                    Funktion / Firma
                  </span>
                  <input
                    data-testid="admin-review-role"
                    type="text"
                    placeholder="Hausverwaltung Vogt GmbH"
                    value={reviewForm.role}
                    onChange={(e) => setReviewForm({ ...reviewForm, role: e.target.value })}
                    className="mt-2 w-full border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none"
                  />
                </label>
                <label className="group block">
                  <span className="font-tac text-[10px] uppercase tracking-[0.3em] text-white/50 transition-colors duration-300 group-focus-within:text-[#F5B301]">
                    Sterne
                  </span>
                  <div className="mt-3 flex items-center gap-2" data-testid="admin-review-rating">
                    {[1, 2, 3, 4, 5].map((n) => (
                      <button
                        key={n}
                        type="button"
                        data-testid={`admin-review-star-${n}`}
                        onClick={() => setReviewForm({ ...reviewForm, rating: n })}
                        aria-label={`${n} Sterne`}
                        className="transition-transform duration-200 hover:scale-110"
                      >
                        <Star className={`h-6 w-6 ${n <= reviewForm.rating ? "fill-[#F5B301] text-[#F5B301]" : "text-white/25"}`} strokeWidth={1.5} />
                      </button>
                    ))}
                  </div>
                </label>
                <label className="group block sm:col-span-2">
                  <span className="font-tac text-[10px] uppercase tracking-[0.3em] text-white/50 transition-colors duration-300 group-focus-within:text-[#F5B301]">
                    Zitat / Text *
                  </span>
                  <textarea
                    data-testid="admin-review-text"
                    rows={3}
                    required
                    placeholder="Was der Kunde über DROPS TFR sagt …"
                    value={reviewForm.text}
                    onChange={(e) => setReviewForm({ ...reviewForm, text: e.target.value })}
                    className="mt-2 w-full resize-none border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none"
                  />
                </label>
                <div className="sm:col-span-2">
                  <button
                    data-testid="admin-review-submit"
                    type="submit"
                    disabled={savingReview}
                    className="group relative overflow-hidden bg-[#F5B301] px-8 py-4 font-tac text-xs font-bold tracking-[0.25em] text-black transition-transform duration-300 hover:scale-[1.02] active:scale-[0.98] disabled:opacity-60"
                  >
                    <span className="relative z-10 flex items-center gap-3">
                      {savingReview && <Loader2 className="h-4 w-4 animate-spin" />}
                      {savingReview ? "WIRD GESPEICHERT ..." : "BEWERTUNG VERÖFFENTLICHEN"}
                    </span>
                  </button>
                </div>
              </form>

              {reviews.length > 0 && (
                <div className="mt-12 border-t border-white/10">
                  {reviews.map((r) => (
                    <div
                      key={r.id}
                      data-testid={`admin-review-${r.id}`}
                      className="grid grid-cols-12 items-center gap-4 border-b border-white/10 py-4"
                    >
                      <span className="col-span-6 font-display text-sm font-black uppercase text-white sm:col-span-3">
                        {r.name}
                      </span>
                      <span className="col-span-6 flex sm:col-span-2">
                        {[1, 2, 3, 4, 5].map((n) => (
                          <Star key={n} className={`h-3.5 w-3.5 ${n <= r.rating ? "fill-[#F5B301] text-[#F5B301]" : "text-white/20"}`} strokeWidth={1.5} />
                        ))}
                      </span>
                      <span className="col-span-11 font-tac text-xs text-white/60 sm:col-span-6">
                        „{r.text.length > 90 ? r.text.slice(0, 90) + "…" : r.text}"
                      </span>
                      <button
                        data-testid={`admin-review-delete-${r.id}`}
                        onClick={() => deleteReview(r.id)}
                        aria-label={`Bewertung von ${r.name} löschen`}
                        className="col-span-1 flex justify-end text-white/40 transition-colors duration-300 hover:text-[#F5B301]"
                      >
                        <Trash2 className="h-4 w-4" />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
            )}

            {activeTab === "kundenportal" && (can("customers") || can("offers")) && (
            <div className="mt-20 border-t border-white/10 pt-14">
              <p className="flex items-center gap-2 font-tac text-xs tracking-[0.3em] text-[#F5B301]">
                <Users className="h-4 w-4" /> KUNDENPORTAL
              </p>
              {can("customers") && (<>
              <h2 className="mt-4 font-display text-3xl font-black uppercase tracking-tighter">
                Dokument für Kunde hochladen
              </h2>
              <p className="mt-3 max-w-xl font-tac text-xs leading-relaxed text-[#A1A1AA]">
                Lade ein PDF für einen registrierten Kunden hoch. Nur dieser Kunde
                sieht und öffnet es in seinem Portal. ({customers.length} Kunde(n) registriert)
              </p>
              <form data-testid="admin-custdoc-form" onSubmit={submitCustDoc} className="mt-8 grid gap-7 sm:grid-cols-2">
                <label className="group block">
                  <span className="font-tac text-[10px] uppercase tracking-[0.3em] text-white/50">Kunde *</span>
                  <select
                    data-testid="admin-custdoc-customer"
                    required
                    value={custDocForm.customer_email}
                    onChange={(e) => setCustDocForm({ ...custDocForm, customer_email: e.target.value })}
                    className="mt-2 w-full border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white focus:border-[#F5B301] focus:outline-none"
                  >
                    <option value="" className="bg-[#09090B]">— Kunde wählen —</option>
                    {customers.map((c) => (
                      <option key={c.email} value={c.email} className="bg-[#09090B]">{c.name} ({c.email})</option>
                    ))}
                  </select>
                </label>
                <label className="group block">
                  <span className="font-tac text-[10px] uppercase tracking-[0.3em] text-white/50">Titel *</span>
                  <input
                    data-testid="admin-custdoc-title"
                    type="text" required
                    placeholder="Einsatzbericht Dachinspektion"
                    value={custDocForm.title}
                    onChange={(e) => setCustDocForm({ ...custDocForm, title: e.target.value })}
                    className="mt-2 w-full border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none"
                  />
                </label>
                <label className="group block sm:col-span-2">
                  <span className="font-tac text-[10px] uppercase tracking-[0.3em] text-white/50">PDF-Datei *</span>
                  <input
                    data-testid="admin-custdoc-file"
                    type="file" required accept="application/pdf,.pdf"
                    onChange={(e) => setCustDocFile(e.target.files[0] || null)}
                    className="mt-2 w-full border-b border-white/20 bg-transparent py-3 font-tac text-xs text-white/60 file:mr-4 file:border file:border-[#F5B301] file:bg-transparent file:px-4 file:py-2 file:font-tac file:text-[10px] file:tracking-[0.2em] file:text-[#F5B301] focus:outline-none"
                  />
                </label>
                <div className="sm:col-span-2">
                  <button
                    data-testid="admin-custdoc-submit" type="submit" disabled={savingCustDoc}
                    className="group relative overflow-hidden bg-[#F5B301] px-8 py-4 font-tac text-xs font-bold tracking-[0.25em] text-black transition-transform duration-300 hover:scale-[1.02] disabled:opacity-60"
                  >
                    <span className="relative z-10 flex items-center gap-3">
                      {savingCustDoc && <Loader2 className="h-4 w-4 animate-spin" />}
                      {savingCustDoc ? "WIRD HOCHGELADEN ..." : "PDF HOCHLADEN"}
                    </span>
                  </button>
                </div>
              </form>

              {custDocs.length > 0 && (
                <div className="mt-12">
                  <h3 className="font-tac text-[10px] tracking-[0.3em] text-white/40">HOCHGELADENE DOKUMENTE</h3>
                  <div className="mt-4 border-t border-white/10">
                    {custDocs.map((d) => (
                      <div key={d.id} data-testid={`admin-custdoc-${d.id}`} className="grid grid-cols-12 items-center gap-4 border-b border-white/10 py-4">
                        <span className="col-span-6 font-tac text-sm text-white sm:col-span-5">{d.title}</span>
                        <span className="col-span-5 font-tac text-xs text-[#F5B301] sm:col-span-6">{d.customer_email}</span>
                        <button data-testid={`admin-custdoc-delete-${d.id}`} onClick={() => deleteCustDoc(d.id)} aria-label="Dokument löschen" className="col-span-1 flex justify-end text-white/40 transition-colors hover:text-[#F5B301]">
                          <Trash2 className="h-4 w-4" />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              </>)}

              {can("offers") && (<>
              <h3 className="mt-14 font-tac text-[10px] tracking-[0.3em] text-white/40">ANGEBOTE (UPLOAD · DIGITALE ZUSAGE)</h3>
              <form data-testid="admin-offer-form" onSubmit={submitOffer} className="mt-4 grid gap-5 sm:grid-cols-4">
                <select data-testid="admin-offer-customer" required value={offerForm.customer_email} onChange={(e) => setOfferForm({ ...offerForm, customer_email: e.target.value })} className="border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white focus:border-[#F5B301] focus:outline-none">
                  <option value="" className="bg-[#09090B]">— Kunde wählen —</option>
                  {customers.map((c) => <option key={c.email} value={c.email} className="bg-[#09090B]">{c.name} ({c.email})</option>)}
                </select>
                <input data-testid="admin-offer-title" required placeholder="Angebot Dachinspektion" value={offerForm.title} onChange={(e) => setOfferForm({ ...offerForm, title: e.target.value })} className="border-b border-white/20 bg-transparent py-3 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none" />
                <label className="flex flex-col gap-1">
                  <span className="font-tac text-[9px] uppercase tracking-[0.25em] text-white/40">Gültig bis (optional)</span>
                  <input data-testid="admin-offer-valid-until" type="date" value={offerForm.valid_until} onChange={(e) => setOfferForm({ ...offerForm, valid_until: e.target.value })} className="border-b border-white/20 bg-transparent py-2 font-tac text-xs text-white focus:border-[#F5B301] focus:outline-none [color-scheme:dark]" />
                </label>
                <input data-testid="admin-offer-file" type="file" required accept="application/pdf,.pdf" onChange={(e) => setOfferFile(e.target.files[0] || null)} className="border-b border-white/20 bg-transparent py-3 font-tac text-xs text-white/60 file:mr-3 file:border file:border-[#F5B301] file:bg-transparent file:px-3 file:py-1.5 file:text-[10px] file:text-[#F5B301]" />
                <div className="sm:col-span-4">
                  <button data-testid="admin-offer-submit" type="submit" disabled={savingOffer} className="flex items-center gap-2 bg-[#F5B301] px-8 py-4 font-tac text-xs font-bold tracking-[0.25em] text-black disabled:opacity-60">
                    {savingOffer && <Loader2 className="h-4 w-4 animate-spin" />} ANGEBOT HOCHLADEN
                  </button>
                </div>
              </form>
              {offers.length > 0 && (
                <div className="mt-6 border-t border-white/10">
                  {offers.map((o) => (
                    <div key={o.id} data-testid={`admin-offer-${o.id}`} className="grid grid-cols-12 items-center gap-4 border-b border-white/10 py-4">
                      <span className="col-span-5 font-tac text-sm text-white sm:col-span-3">{o.title}</span>
                      <span className="col-span-4 font-tac text-xs text-[#F5B301] sm:col-span-3">{o.customer_email}</span>
                      <span className="col-span-3 font-tac text-[10px] text-white/45 sm:col-span-2">{o.valid_until ? `bis ${o.valid_until}` : "—"}</span>
                      <span className={`col-span-2 font-tac text-[9px] tracking-[0.2em] sm:col-span-3 ${o.status === "angenommen" ? "text-emerald-400" : o.status === "abgelaufen" ? "text-red-400" : o.status === "widerrufen" ? "text-white/40" : "text-white/60"}`}>{o.status?.toUpperCase()}</span>
                      <button data-testid={`admin-offer-delete-${o.id}`} onClick={() => deleteOffer(o.id)} aria-label="Angebot löschen" className="col-span-1 flex justify-end text-white/40 hover:text-[#F5B301]"><Trash2 className="h-4 w-4" /></button>
                    </div>
                  ))}
                </div>
              )}
              </>)}

              {can("customers") && (<>
              <h3 className="mt-14 font-tac text-[10px] tracking-[0.3em] text-white/40">EINSATZ-ANFRAGEN DER KUNDEN</h3>
              <div className="mt-4 border-t border-white/10" data-testid="admin-custrequests">
                {custRequests.length === 0 ? (
                  <p className="py-6 font-tac text-xs text-white/40">Noch keine Anfragen aus dem Portal.</p>
                ) : custRequests.map((r) => (
                  <div key={r.id} data-testid={`admin-custreq-${r.id}`} className="border-b border-white/10 py-4">
                    <div className="grid grid-cols-12 items-center gap-4">
                      <span className="col-span-12 font-display text-sm font-black uppercase text-white sm:col-span-3">{r.title}</span>
                      <span className="col-span-6 font-tac text-xs text-white/60 sm:col-span-3">{r.customer_name} · {r.customer_email}</span>
                      <span className="col-span-6 font-tac text-xs text-white/50 sm:col-span-3">{r.ort} · {r.wunschdatum}</span>
                      <button
                        data-testid={`admin-custreq-toggle-${r.id}`}
                        onClick={() => toggleRequest(r)}
                        disabled={r.status === "widerrufen"}
                        className={`col-span-12 flex w-fit items-center gap-2 border px-3 py-1.5 font-tac text-[10px] tracking-[0.2em] transition-colors sm:col-span-3 ${r.status === "erledigt" ? "border-emerald-400/40 text-emerald-400" : r.status === "widerrufen" ? "border-white/15 text-white/40" : "border-[#F5B301]/40 text-[#F5B301]"}`}
                      >
                        {r.status === "erledigt" ? <Check className="h-3.5 w-3.5" /> : null}
                        {r.status === "widerrufen" ? "WIDERRUFEN" : r.status === "erledigt" ? "ERLEDIGT" : "ALS ERLEDIGT MARKIEREN"}
                      </button>
                    </div>
                    {Array.isArray(r.history) && r.history.length > 0 ? (
                      <ol className="mt-3 space-y-1.5 border-l border-white/10 pl-3" data-testid={`admin-custreq-history-${r.id}`}>
                        {r.history.map((h, i) => (
                          <li key={i} className="flex items-start gap-2 font-tac text-[10px] text-white/45">
                            <Clock className="mt-0.5 h-3 w-3 shrink-0 text-white/30" />
                            <span><span className="text-white/70">{statusLabel(h.status)}</span> · {fmtDT(h.at)}{h.note ? ` — ${h.note}` : ""}</span>
                          </li>
                        ))}
                      </ol>
                    ) : (
                      <p className="mt-2 font-tac text-[10px] text-white/35">Eingereicht am {fmtDT(r.created_at)}</p>
                    )}
                    {r.einsatzort_adresse && (
                      <div className="mt-2" data-testid={`admin-custreq-map-${r.id}`}>
                        <p className="font-tac text-[11px] text-white/50">Einsatzort-Adresse: <span className="text-white/70">{r.einsatzort_adresse}</span></p>
                        <div className="mt-2 max-w-md overflow-hidden border border-white/10">
                          <iframe title={`Karte ${r.id}`} className="h-48 w-full" loading="lazy" referrerPolicy="no-referrer-when-downgrade" src={`https://maps.google.com/maps?q=${encodeURIComponent(r.einsatzort_adresse)}&z=14&output=embed`} />
                        </div>
                        <a data-testid={`admin-custreq-route-${r.id}`} href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(r.einsatzort_adresse)}`} target="_blank" rel="noreferrer" className="mt-2 inline-flex items-center gap-1.5 font-tac text-[10px] tracking-[0.2em] text-[#F5B301] hover:underline">ROUTE ÖFFNEN →</a>
                      </div>
                    )}
                    {Array.isArray(r.images) && r.images.length > 0 && (
                      <div className="mt-3 flex flex-wrap gap-2" data-testid={`admin-custreq-images-${r.id}`}>
                        {r.images.map((_, i) => (
                          <a key={i} href={`${API}/request-image/${r.id}/${i}`} target="_blank" rel="noreferrer"><img src={`${API}/request-image/${r.id}/${i}`} alt="Anfrage-Foto" className="h-20 w-20 border border-white/10 object-cover transition-opacity hover:opacity-80" /></a>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
              </>)}
            </div>
            )}

            {activeTab === "kunden" && can("customers") && (
            <div className="mt-10" data-testid="admin-customers-section">
              <p className="flex items-center gap-2 font-tac text-xs tracking-[0.3em] text-[#F5B301]">
                <Users className="h-4 w-4" /> KUNDENADMINISTRATION
              </p>
              <h2 className="mt-4 font-display text-3xl font-black uppercase tracking-tighter">Kunden verwalten</h2>
              <p className="mt-3 max-w-xl font-tac text-xs leading-relaxed text-[#A1A1AA]">
                Übersicht aller registrierten Kunden. Beim Löschen werden Konto und ALLE zugehörigen Daten (Anfragen, Dokumente, Angebote, Support-Tickets) unwiderruflich entfernt.
              </p>
              {customers.length === 0 ? (
                <p className="mt-8 font-tac text-xs text-white/40">Noch keine Kunden registriert.</p>
              ) : (
                <div className="mt-8 border-t border-white/10" data-testid="admin-customer-list">
                  {customers.map((c) => (
                    <div key={c.email} data-testid={`admin-customer-${c.email}`} className="flex flex-wrap items-center gap-x-4 gap-y-2 border-b border-white/10 py-4">
                      <div className="min-w-[180px] flex-1">
                        <p className="font-tac text-sm text-white">{c.name || "—"}</p>
                        <p className="font-tac text-[11px] text-white/45">{c.email}</p>
                      </div>
                      <span className="font-tac text-[10px] tracking-[0.15em] text-[#F5B301]">{c.auth_provider === "google" ? "GOOGLE" : "E-MAIL"}</span>
                      <span data-testid={`admin-customer-status-${c.email}`} className={`px-1.5 py-0.5 font-tac text-[9px] tracking-[0.15em] ${(c.customer_status || "approved") === "approved" ? "bg-emerald-500/15 text-emerald-400" : (c.customer_status || "approved") === "blocked" ? "bg-red-500/15 text-red-400" : "bg-[#F5B301]/15 text-[#F5B301]"}`}>{(c.customer_status || "approved") === "approved" ? "FREIGESCHALTET" : (c.customer_status || "approved") === "blocked" ? "GESPERRT" : "PRÜFUNG"}</span>
                      <span className="font-tac text-[10px] text-white/40">{c.request_count || 0} Anfr. · {c.document_count || 0} Dok. · {c.ticket_count || 0} Tick.</span>
                      <div className="ml-auto flex items-center gap-2">
                        {(c.customer_status || "approved") !== "approved" && (
                          <button data-testid={`admin-customer-approve-${c.email}`} onClick={() => setCustomerStatus(c.email, "approved")} className="flex items-center gap-1 border border-emerald-500/40 px-2.5 py-1 font-tac text-[9px] tracking-[0.15em] text-emerald-400 transition-colors hover:bg-emerald-500/10"><Check className="h-3 w-3" /> FREISCHALTEN</button>
                        )}
                        {(c.customer_status || "approved") !== "blocked" ? (
                          <button data-testid={`admin-customer-block-${c.email}`} onClick={() => setCustomerStatus(c.email, "blocked")} className="border border-white/20 px-2.5 py-1 font-tac text-[9px] tracking-[0.15em] text-white/60 transition-colors hover:border-red-400 hover:text-red-400">SPERREN</button>
                        ) : (
                          <button data-testid={`admin-customer-reactivate-${c.email}`} onClick={() => setCustomerStatus(c.email, "approved")} className="border border-white/20 px-2.5 py-1 font-tac text-[9px] tracking-[0.15em] text-white/60 transition-colors hover:border-emerald-400 hover:text-emerald-400">REAKTIVIEREN</button>
                        )}
                        <button data-testid={`admin-customer-delete-${c.email}`} onClick={() => deleteCustomer(c.email)} aria-label={`Kunde ${c.email} löschen`} className="text-white/40 hover:text-red-400"><Trash2 className="h-3.5 w-3.5" /></button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            )}

            {activeTab === "support" && can("customers") && (
            <div className="mt-10" data-testid="admin-support-section">
              <p className="flex items-center gap-2 font-tac text-xs tracking-[0.3em] text-[#F5B301]">
                <FileText className="h-4 w-4" /> KUNDEN-SUPPORT
              </p>
              <h2 className="mt-4 font-display text-3xl font-black uppercase tracking-tighter">Support-Tickets</h2>
              <p className="mt-3 max-w-xl font-tac text-xs leading-relaxed text-[#A1A1AA]">
                Anfragen von Kunden bei Problemen. Antworte direkt und setze den Status. Der Kunde sieht Antworten und Status in seinem Portal.
              </p>
              {tickets.length === 0 ? (
                <p className="mt-8 font-tac text-xs text-white/40">Noch keine Support-Tickets.</p>
              ) : (
                <div className="mt-8 space-y-5" data-testid="admin-ticket-list">
                  {tickets.map((t) => (
                    <div key={t.id} data-testid={`admin-ticket-${t.id}`} className="border border-white/10 bg-white/[0.02] p-5">
                      <div className="flex flex-wrap items-start justify-between gap-3">
                        <div>
                          <p className="font-display text-lg font-black uppercase tracking-tight text-white">{t.subject}</p>
                          <p className="mt-1 font-tac text-[11px] text-white/45">{t.customer_name} · {t.customer_email}{t.mission_ref ? ` · Einsatz ${t.mission_ref}` : ""}</p>
                        </div>
                        <select
                          data-testid={`admin-ticket-status-${t.id}`}
                          value={t.status}
                          onChange={(e) => setTicketStatus(t.id, e.target.value)}
                          className={`border bg-transparent px-3 py-2 font-tac text-[10px] tracking-[0.15em] focus:outline-none [&>option]:bg-[#09090B] ${t.status === "geloest" ? "border-green-500/40 text-green-400" : t.status === "in_bearbeitung" ? "border-[#F5B301]/40 text-[#F5B301]" : "border-white/20 text-white/70"}`}
                        >
                          <option value="offen">OFFEN</option>
                          <option value="in_bearbeitung">IN BEARBEITUNG</option>
                          <option value="geloest">GELÖST</option>
                        </select>
                      </div>
                      <div className="mt-4 space-y-2 border-t border-white/10 pt-4">
                        {(t.messages || []).map((m) => (
                          <div key={m.id} className={`max-w-[85%] border p-3 ${m.sender === "staff" ? "ml-auto border-[#F5B301]/30 bg-[#F5B301]/5" : "border-white/10 bg-white/[0.02]"}`}>
                            <p className="font-tac text-[9px] tracking-[0.2em] text-white/40">{m.sender === "staff" ? "DROPS TFR" : m.sender_name} · {fmtDT(m.at)}</p>
                            <p className="mt-1 font-tac text-xs leading-relaxed text-white/80">{m.text}</p>
                          </div>
                        ))}
                      </div>
                      <div className="mt-4 flex flex-col gap-2 sm:flex-row">
                        <input
                          data-testid={`admin-ticket-reply-input-${t.id}`}
                          value={ticketReply[t.id] || ""}
                          onChange={(e) => setTicketReply({ ...ticketReply, [t.id]: e.target.value })}
                          onKeyDown={(e) => { if (e.key === "Enter") replyTicket(t.id); }}
                          placeholder="Antwort an den Kunden…"
                          className="flex-1 border-b border-white/20 bg-transparent py-2 font-tac text-xs text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none"
                        />
                        <button data-testid={`admin-ticket-reply-${t.id}`} onClick={() => replyTicket(t.id)} className="bg-[#F5B301] px-5 py-2 font-tac text-[10px] font-bold tracking-[0.2em] text-black">ANTWORTEN</button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            )}

            {activeTab === "bilder" && can("gallery") && <SiteImages />}

            {activeTab === "livechat" && can("customers") && (
            <div className="mt-10" data-testid="admin-livechat-section">
              <p className="flex items-center gap-2 font-tac text-xs tracking-[0.3em] text-[#F5B301]"><MessageSquare className="h-4 w-4" /> LIVE-CHAT</p>
              <h2 className="mt-4 font-display text-3xl font-black uppercase tracking-tighter">Kunden-Chat</h2>
              <p className="mt-3 max-w-xl font-tac text-xs leading-relaxed text-[#A1A1AA]">Direkte Kommunikation mit Kunden in Near-Realtime. Wähle links eine Konversation — ungelesene Nachrichten sind markiert. Fotos werden inline angezeigt.</p>
              <div className="mt-8 grid gap-4 lg:grid-cols-3">
                <div className="max-h-[30rem] overflow-y-auto border border-white/10 lg:col-span-1" data-testid="admin-chat-threads">
                  {chatThreads.length === 0 ? (
                    <p className="p-4 font-tac text-xs text-white/40">Noch keine Chats.</p>
                  ) : chatThreads.map((t) => (
                    <button key={t.customer_email} data-testid={`admin-chat-thread-${t.customer_email}`} onClick={() => openThread(t.customer_email)} className={`flex w-full items-center justify-between gap-2 border-b border-white/10 p-3 text-left transition-colors ${chatEmail === t.customer_email ? "bg-[#F5B301]/10" : "hover:bg-white/[0.03]"}`}>
                      <div className="min-w-0">
                        <p className="truncate font-tac text-xs text-white">{t.customer_name || t.customer_email}</p>
                        <p className="truncate font-tac text-[10px] text-white/45">{t.last_sender === "staff" ? "Du: " : ""}{t.last_text}</p>
                      </div>
                      {t.unread > 0 && <span data-testid={`admin-chat-unread-${t.customer_email}`} className="shrink-0 bg-[#F5B301] px-1.5 py-0.5 font-tac text-[9px] font-bold text-black">{t.unread}</span>}
                    </button>
                  ))}
                </div>
                <div className="border border-white/10 bg-white/[0.02] lg:col-span-2">
                  {!chatEmail ? (
                    <p className="p-6 font-tac text-xs text-white/40">Wähle links eine Konversation, um zu antworten.</p>
                  ) : (<>
                    <div className="border-b border-white/10 px-4 py-3"><p className="font-tac text-[11px] tracking-[0.2em] text-[#F5B301]">{chatEmail}</p></div>
                    <div className="h-80 space-y-3 overflow-y-auto p-4" data-testid="admin-chat-messages">
                      {chatMsgs.length === 0 ? (
                        <p className="font-tac text-xs text-white/40">Noch keine Nachrichten.</p>
                      ) : chatMsgs.map((m) => (
                        <div key={m.id} data-testid={`admin-chat-msg-${m.sender}`} className={`max-w-[80%] border p-2.5 ${m.sender === "staff" ? "ml-auto border-[#F5B301]/30 bg-[#F5B301]/5" : "border-white/10 bg-white/[0.02]"}`}>
                          <p className="font-tac text-[9px] tracking-[0.2em] text-white/40">{m.sender === "staff" ? (m.sender_name || "DROPS TFR") : "KUNDE"} · {fmtDT(m.at)}</p>
                          {m.has_image ? (
                            <img src={`${API}/chat-image/${m.id}`} alt="Foto" className="mt-2 max-h-52 w-auto border border-white/10 object-contain" />
                          ) : m.has_file ? (
                            <a href={`${API}/chat-file/${m.id}`} target="_blank" rel="noreferrer" className="mt-2 flex items-center gap-2 font-tac text-xs text-[#F5B301] underline"><FileText className="h-4 w-4" /> {m.file_name || "Dokument.pdf"}</a>
                          ) : (
                            <p className="mt-1 font-tac text-xs leading-relaxed text-white/85">{m.text}</p>
                          )}
                        </div>
                      ))}
                      <div ref={chatEndRef} />
                    </div>
                    <div className="flex items-center gap-2 border-t border-white/10 p-3">
                      <input ref={chatFileRef} type="file" accept="image/*,application/pdf" className="hidden" data-testid="admin-chat-file" onChange={(e) => sendChatImg(e.target.files[0])} />
                      <button type="button" data-testid="admin-chat-attach" onClick={() => chatFileRef.current?.click()} disabled={chatSending} aria-label="Foto oder PDF senden" className="flex h-9 w-9 shrink-0 items-center justify-center border border-white/20 text-white/70 transition-colors hover:border-[#F5B301] hover:text-[#F5B301] disabled:opacity-60"><Paperclip className="h-4 w-4" /></button>
                      <input data-testid="admin-chat-input" value={chatInput} onChange={(e) => setChatInput(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") sendChatMsg(); }} placeholder="Antwort an den Kunden…" className="flex-1 border-b border-white/20 bg-transparent py-2 font-tac text-xs text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none" />
                      <button type="button" data-testid="admin-chat-send" onClick={sendChatMsg} disabled={chatSending} aria-label="Senden" className="flex h-9 w-9 shrink-0 items-center justify-center bg-[#F5B301] text-black disabled:opacity-60">{chatSending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}</button>
                    </div>
                  </>)}
                </div>
              </div>
            </div>
            )}

            {activeTab === "kalender" && can("customers") && (
            <div className="mt-10" data-testid="admin-kalender-section">
              <p className="flex items-center gap-2 font-tac text-xs tracking-[0.3em] text-[#F5B301]">
                <Calendar className="h-4 w-4" /> TERMINKALENDER
              </p>
              <h2 className="mt-4 font-display text-3xl font-black uppercase tracking-tighter">Termine</h2>
              <p className="mt-3 max-w-xl font-tac text-xs leading-relaxed text-[#A1A1AA]">Lege Termine an und weise sie optional einem Kunden zu (per E-Mail). Der Kunde sieht nur seine eigenen Termine — fremde erscheinen bei ihm gesperrt.</p>
              <form data-testid="admin-appt-form" onSubmit={submitAppointment} className="mt-8 grid gap-3 sm:grid-cols-3">
                <input data-testid="admin-appt-title" placeholder="Titel*" value={apptForm.title} onChange={(e) => setApptForm({ ...apptForm, title: e.target.value })} className="border-b border-white/20 bg-transparent py-2 font-tac text-xs text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none sm:col-span-2" />
                <input data-testid="admin-appt-date" type="date" value={apptForm.date} onChange={(e) => setApptForm({ ...apptForm, date: e.target.value })} className="border-b border-white/20 bg-transparent py-2 font-tac text-xs text-white focus:border-[#F5B301] focus:outline-none [color-scheme:dark]" />
                <input data-testid="admin-appt-start" type="time" value={apptForm.start} onChange={(e) => setApptForm({ ...apptForm, start: e.target.value })} className="border-b border-white/20 bg-transparent py-2 font-tac text-xs text-white focus:border-[#F5B301] focus:outline-none [color-scheme:dark]" />
                <input data-testid="admin-appt-end" type="time" value={apptForm.end} onChange={(e) => setApptForm({ ...apptForm, end: e.target.value })} className="border-b border-white/20 bg-transparent py-2 font-tac text-xs text-white focus:border-[#F5B301] focus:outline-none [color-scheme:dark]" />
                <input data-testid="admin-appt-location" placeholder="Ort" value={apptForm.location} onChange={(e) => setApptForm({ ...apptForm, location: e.target.value })} className="border-b border-white/20 bg-transparent py-2 font-tac text-xs text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none" />
                <input data-testid="admin-appt-customer" placeholder="Kunde E-Mail (optional)" value={apptForm.customer_email} onChange={(e) => setApptForm({ ...apptForm, customer_email: e.target.value })} className="border-b border-white/20 bg-transparent py-2 font-tac text-xs text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none sm:col-span-2" />
                <input data-testid="admin-appt-note" placeholder="Notiz" value={apptForm.note} onChange={(e) => setApptForm({ ...apptForm, note: e.target.value })} className="border-b border-white/20 bg-transparent py-2 font-tac text-xs text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none sm:col-span-3" />
                <div className="sm:col-span-3 flex items-center gap-3"><button data-testid="admin-appt-submit" type="submit" disabled={savingAppt} className="flex items-center gap-2 bg-[#F5B301] px-6 py-2.5 font-tac text-[10px] font-bold tracking-[0.2em] text-black disabled:opacity-60">{savingAppt && <Loader2 className="h-3 w-3 animate-spin" />} {editApptId ? "TERMIN SPEICHERN" : "TERMIN ANLEGEN"}</button>{editApptId && <button type="button" data-testid="admin-appt-edit-cancel" onClick={cancelEditAppt} className="font-tac text-[10px] tracking-[0.2em] text-white/50 hover:text-white">ABBRECHEN</button>}</div>
              </form>
              <div className="mt-8 border-t border-white/10" data-testid="admin-appt-list">
                {appointments.length === 0 ? (
                  <p className="py-6 font-tac text-xs text-white/40">Noch keine Termine.</p>
                ) : appointments.map((a) => (
                  <div key={a.id} data-testid={`admin-appt-${a.id}`} className="flex flex-wrap items-center gap-x-4 gap-y-2 border-b border-white/10 py-3">
                    <span className="font-tac text-xs tracking-[0.15em] text-[#F5B301]">{a.date}{a.start ? ` · ${a.start}` : ""}{a.end ? `–${a.end}` : ""}</span>
                    <span className="font-tac text-sm text-white">{a.title}</span>
                    {a.location && <span className="font-tac text-[11px] text-white/50">{a.location}</span>}
                    <span className="font-tac text-[11px] text-white/45">{a.customer_email || "—"}</span>
                    <span data-testid={`admin-appt-status-${a.id}`} className={`px-1.5 py-0.5 font-tac text-[9px] tracking-[0.15em] ${apptBadgeCls(a.status || "ausstehend")}`}>{statusLabel(a.status || "ausstehend").toUpperCase()}</span>
                    {a.source === "customer" && <span data-testid={`admin-appt-kundenwunsch-${a.id}`} className="px-1.5 py-0.5 font-tac text-[9px] tracking-[0.15em] bg-sky-500/15 text-sky-400">KUNDENWUNSCH</span>}
                    <div className="ml-auto flex items-center gap-2">
                      {(a.status || "ausstehend") !== "bestaetigt" && (
                        <button data-testid={`admin-appt-confirm-${a.id}`} onClick={() => setApptStatus(a.id, "bestaetigt")} className="flex items-center gap-1 border border-emerald-500/40 px-2.5 py-1 font-tac text-[9px] tracking-[0.15em] text-emerald-400 transition-colors hover:bg-emerald-500/10"><Check className="h-3 w-3" /> BESTÄTIGEN</button>
                      )}
                      <button data-testid={`admin-appt-edit-${a.id}`} onClick={() => startEditAppt(a)} className="border border-white/20 px-2.5 py-1 font-tac text-[9px] tracking-[0.15em] text-white/60 transition-colors hover:border-[#F5B301] hover:text-[#F5B301]">ANPASSEN</button>
                      {(a.status || "ausstehend") !== "storniert" && (
                        <button data-testid={`admin-appt-cancel-${a.id}`} onClick={() => setApptStatus(a.id, "storniert")} className="border border-white/20 px-2.5 py-1 font-tac text-[9px] tracking-[0.15em] text-white/60 transition-colors hover:border-red-400 hover:text-red-400">STORNIEREN</button>
                      )}
                      <button data-testid={`admin-appt-delete-${a.id}`} onClick={() => deleteAppointment(a.id)} aria-label="Termin löschen" className="text-white/40 hover:text-red-400"><Trash2 className="h-4 w-4" /></button>
                    </div>
                    {a.location && (
                      <div className="w-full" data-testid={`admin-appt-map-${a.id}`}>
                        <div className="mt-2 max-w-md overflow-hidden border border-white/10">
                          <iframe title={`Karte Termin ${a.id}`} className="h-40 w-full" loading="lazy" referrerPolicy="no-referrer-when-downgrade" src={`https://maps.google.com/maps?q=${encodeURIComponent(a.location)}&z=14&output=embed`} />
                        </div>
                        <a data-testid={`admin-appt-route-${a.id}`} href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(a.location)}`} target="_blank" rel="noreferrer" className="mt-2 inline-flex items-center gap-1.5 font-tac text-[10px] tracking-[0.2em] text-[#F5B301] hover:underline">ROUTE ÖFFNEN →</a>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
            )}

            {activeTab === "statistik" && isAdmin && (
            <div className="mt-10" data-testid="admin-statistik-section">
              <p className="flex items-center gap-2 font-tac text-xs tracking-[0.3em] text-[#F5B301]">
                <Clock className="h-4 w-4" /> STATISTIK
              </p>
              <h2 className="mt-4 font-display text-3xl font-black uppercase tracking-tighter">Besucher & Kennzahlen</h2>

              <div className="mt-8 grid gap-4 sm:grid-cols-3" data-testid="admin-visits">
                <div className="border border-white/10 bg-white/[0.02] p-5">
                  <p className="font-tac text-[10px] tracking-[0.25em] text-white/40">BESUCHE GESAMT</p>
                  <p className="mt-2 font-display text-4xl font-black text-[#F5B301]">{visitStats ? visitStats.total.toLocaleString("de-DE") : "—"}</p>
                </div>
                <div className="border border-white/10 bg-white/[0.02] p-5">
                  <p className="font-tac text-[10px] tracking-[0.25em] text-white/40">HEUTE</p>
                  <p className="mt-2 font-display text-4xl font-black text-white">{visitStats ? visitStats.today.toLocaleString("de-DE") : "—"}</p>
                </div>
                <div className="border border-white/10 bg-white/[0.02] p-5">
                  <p className="font-tac text-[10px] tracking-[0.25em] text-white/40">LETZTE 7 TAGE</p>
                  <div className="mt-3 flex items-end gap-1.5" data-testid="admin-visits-7d">
                    {visitStats?.last7?.map((d) => {
                      const max = Math.max(1, ...visitStats.last7.map((x) => x.count));
                      return (
                        <div key={d.date} className="flex flex-1 flex-col items-center gap-1" title={`${d.date}: ${d.count}`}>
                          <div className="w-full bg-[#F5B301]/70" style={{ height: `${Math.max(3, (d.count / max) * 44)}px` }} />
                          <span className="font-tac text-[8px] text-white/30">{d.date.slice(8)}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              <div className="mt-12 border-t border-white/10 pt-10">
                <div className="flex flex-wrap items-center justify-between gap-3">
                  <h3 className="font-tac text-[11px] tracking-[0.3em] text-[#F5B301]">KENNZAHLEN AUF DER STARTSEITE</h3>
                  <div className="flex items-center gap-4">
                    <button data-testid="admin-stat-add" onClick={addStatItem} className="font-tac text-[10px] tracking-[0.2em] text-white/60 hover:text-[#F5B301]">+ KENNZAHL</button>
                    <button data-testid="admin-stat-save" onClick={saveSiteStats} disabled={savingStats} className="flex items-center gap-2 bg-[#F5B301] px-6 py-2.5 font-tac text-[10px] font-bold tracking-[0.2em] text-black disabled:opacity-60">{savingStats && <Loader2 className="h-3 w-3 animate-spin" />} SPEICHERN</button>
                  </div>
                </div>
                <p className="mt-2 font-tac text-[11px] text-white/40">Beschriftung, Wert und optionale Einheit (z. B. „+", „h"). Erscheint als animiertes Zähler-Band auf der Startseite.</p>
                <div className="mt-6 space-y-3" data-testid="admin-stat-list">
                  {siteStats.map((it) => (
                    <div key={it.id} data-testid={`admin-stat-${it.id}`} className="grid grid-cols-12 items-center gap-3 border border-white/10 p-3">
                      <input data-testid={`admin-stat-label-${it.id}`} value={it.label} onChange={(e) => updateStatItem(it.id, "label", e.target.value)} placeholder="Beschriftung" className="col-span-12 border-b border-white/15 bg-transparent py-2 font-tac text-xs text-white focus:border-[#F5B301] focus:outline-none sm:col-span-4" />
                      <select data-testid={`admin-stat-icon-${it.id}`} value={it.icon || ""} onChange={(e) => updateStatItem(it.id, "icon", e.target.value)} className="col-span-6 border-b border-white/15 bg-transparent py-2 font-tac text-[11px] tracking-[0.1em] text-white/70 focus:border-[#F5B301] focus:outline-none [&>option]:bg-[#09090B] sm:col-span-3">
                        <option value="">Kein Icon</option>
                        <option value="plane">✈ Flüge</option>
                        <option value="clock">⏱ Stunden / Zeit</option>
                        <option value="target">◎ Einsätze / Ziel</option>
                        <option value="award">★ Erfahrung / Award</option>
                        <option value="camera">▣ Kamera / Foto</option>
                        <option value="ruler">📏 Vermessung</option>
                        <option value="scan">⛶ Inspektion</option>
                        <option value="building">▢ Gebäude</option>
                        <option value="users">☺ Kunden / Team</option>
                        <option value="shield">⛨ Sicherheit</option>
                        <option value="mountain">▲ Gelände</option>
                        <option value="zap">⚡ Energie</option>
                      </select>
                      <input data-testid={`admin-stat-value-${it.id}`} value={it.value} onChange={(e) => updateStatItem(it.id, "value", e.target.value)} placeholder="Wert" className="col-span-6 border-b border-white/15 bg-transparent py-2 font-tac text-xs text-[#F5B301] focus:border-[#F5B301] focus:outline-none sm:col-span-2" />
                      <input data-testid={`admin-stat-suffix-${it.id}`} value={it.suffix || ""} onChange={(e) => updateStatItem(it.id, "suffix", e.target.value)} placeholder="Einheit" className="col-span-4 border-b border-white/15 bg-transparent py-2 font-tac text-xs text-white/60 focus:border-[#F5B301] focus:outline-none sm:col-span-2" />
                      <button data-testid={`admin-stat-remove-${it.id}`} onClick={() => removeStatItem(it.id)} aria-label="Entfernen" className="col-span-2 flex justify-end text-white/40 hover:text-red-400 sm:col-span-1"><Trash2 className="h-4 w-4" /></button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            )}

            {activeTab === "faq" && isAdmin && (
            <div className="mt-10" data-testid="admin-faq-section">
              <p className="flex items-center gap-2 font-tac text-xs tracking-[0.3em] text-[#F5B301]">
                <FileText className="h-4 w-4" /> FAQ
              </p>
              <h2 className="mt-4 font-display text-3xl font-black uppercase tracking-tighter">Häufige Fragen</h2>
              <p className="mt-3 max-w-xl font-tac text-xs leading-relaxed text-[#A1A1AA]">Diese Fragen & Antworten erscheinen als Akkordeon auf der Startseite. Änderungen an bestehenden Einträgen werden beim Verlassen des Feldes gespeichert.</p>
              <form data-testid="admin-faq-form" onSubmit={submitFaq} className="mt-8 grid gap-3">
                <input data-testid="admin-faq-question" placeholder="Frage" value={faqForm.question} onChange={(e) => setFaqForm({ ...faqForm, question: e.target.value })} className="border-b border-white/20 bg-transparent py-2 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none" />
                <textarea data-testid="admin-faq-answer" placeholder="Antwort" rows={2} value={faqForm.answer} onChange={(e) => setFaqForm({ ...faqForm, answer: e.target.value })} className="border-b border-white/20 bg-transparent py-2 font-tac text-sm text-white placeholder:text-white/25 focus:border-[#F5B301] focus:outline-none" />
                <div><button data-testid="admin-faq-submit" type="submit" disabled={savingFaq} className="flex items-center gap-2 bg-[#F5B301] px-6 py-2.5 font-tac text-[10px] font-bold tracking-[0.2em] text-black disabled:opacity-60">{savingFaq && <Loader2 className="h-3 w-3 animate-spin" />} FRAGE HINZUFÜGEN</button></div>
              </form>
              <div className="mt-8 space-y-3" data-testid="admin-faq-list">
                {faqs.map((f) => (
                  <div key={f.id} data-testid={`admin-faq-${f.id}`} className="border border-white/10 p-4">
                    <div className="flex items-start justify-between gap-3">
                      <input defaultValue={f.question} onBlur={(e) => saveFaqEdit(f.id, e.target.value, f.answer)} className="flex-1 border-b border-white/15 bg-transparent py-1 font-tac text-sm font-bold text-white focus:border-[#F5B301] focus:outline-none" />
                      <button data-testid={`admin-faq-delete-${f.id}`} onClick={() => deleteFaq(f.id)} aria-label="FAQ löschen" className="text-white/40 hover:text-red-400"><Trash2 className="h-4 w-4" /></button>
                    </div>
                    <textarea defaultValue={f.answer} onBlur={(e) => saveFaqEdit(f.id, f.question, e.target.value)} rows={2} className="mt-2 w-full border-b border-white/15 bg-transparent py-1 font-tac text-xs text-white/60 focus:border-[#F5B301] focus:outline-none" />
                  </div>
                ))}
              </div>
            </div>
            )}

            {activeTab === "protokoll" && isAdmin && (
            <div className="mt-20 border-t border-white/10 pt-14" data-testid="admin-activity-section">
              <p className="flex items-center gap-2 font-tac text-xs tracking-[0.3em] text-[#F5B301]">
                <Clock className="h-4 w-4" /> AKTIVITÄTS-PROTOKOLL
              </p>
              <h2 className="mt-4 font-display text-3xl font-black uppercase tracking-tighter">
                Wer hat was geändert
              </h2>
              <p className="mt-3 max-w-xl font-tac text-xs leading-relaxed text-[#A1A1AA]">
                Chronologisches Protokoll aller Änderungen durch Admin- und Team-Mitglieder (neueste zuerst, max. 200 Einträge).
              </p>
              <div className="mt-8 border-t border-white/10" data-testid="admin-activity-list">
                {activity.length === 0 ? (
                  <p className="py-6 font-tac text-xs text-white/40">Noch keine Aktivitäten protokolliert.</p>
                ) : activity.map((a) => (
                  <div key={a.id} data-testid={`admin-activity-${a.id}`} className="grid grid-cols-12 items-center gap-4 border-b border-white/10 py-3">
                    <span className="col-span-12 font-tac text-sm text-white sm:col-span-4">{a.action}</span>
                    <span className="col-span-6 font-tac text-xs text-[#F5B301] sm:col-span-4">{a.actor_name} <span className="text-white/40">· {a.actor_role === "admin" ? "Admin" : "Team"}</span></span>
                    <span className="col-span-6 font-tac text-[10px] tracking-[0.15em] text-white/45 sm:col-span-4 sm:text-right">{fmtDT(a.at)}</span>
                  </div>
                ))}
              </div>
            </div>
            )}
          </motion.div>
        )}
      </main>
    </div>
  );
}
